import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import * as moment from 'moment';
import { SelectItem, Keys } from 'lib/common';
import { Column, DataManager, CdtSettings } from 'lib/ng-crud-table';
import { FilterOperator } from 'lib/ng-data-table/base';
import { GetMapColumnAliia } from 'src/app/shared/models';
import { DtMessages, DtMessagesEn } from 'lib/dt-translate';
import { getColumnsPlayers, getConfigColumnsHeaders } from 'src/app/shared/columns';
import { HttpClient } from '@angular/common/http';
import { Subscription, config } from 'rxjs';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { FiltersService } from 'src/app/shared/services/filters/filters.service';
import { MAINFILTER, RatingOperator } from 'src/app/shared/models/MAINFILTER';
import { GoogleMapsService } from 'src/app/shared/services/google-maps/google-maps.service';
import { MAPREGION } from 'src/app/shared/models/MAPREGION';
import { DataFilter } from 'lib/ng-data-table/base/data-filter';
import { DemoService } from 'src/app/shared/demo.service';
import { promise } from 'protractor';

@Component({
  selector: 'app-search-criteria',
  templateUrl: './search-criteria.component.html',
  styleUrls: ['./search-criteria.component.scss', '../../styles/input.css', '../../styles/select-list.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SearchCriteriaComponent implements OnInit, OnChanges {

  //Region section
  regions: SelectItem[] = [];
  selectedRegions: number[] = [];
  authorizeCreateFilter: boolean = true;
  authorizeModifyFilter: boolean = true;
  authorizeDeleteFilter: boolean = true;
  isTableRowSelected: boolean = false;

  LoggedinUserName: string;

  //Custom date range
  selectedTime: any;
  @ViewChild('dateInput', { static: true }) dateInput: ElementRef;
  ranges: any = {
    'Last 10 Minutes': [moment().subtract(13, 'minutes'), moment()],
    'Last Hour': [moment().subtract(1, 'hours'), moment()],
    //'12 Hours': [moment().subtract(12, 'hours'), moment()],
    //'24 Hours': [moment().subtract(24, 'hours'), moment()],
    Today: [moment().hour(0).minute(0), moment().hour(23).minute(59)],
    Yesterday: [moment().subtract(1, 'days').hour(0).minute(0), moment().subtract(1, 'days').hour(23).minute(59)],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    //'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    //'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [
      moment()
        .subtract(1, 'month')
        .startOf('month'),
      moment()
        .subtract(1, 'month')
        .endOf('month')
    ],
    'Last 6 Months': [
      moment()
        .subtract(6, 'month')
        .startOf('month'),
      moment()
        .subtract(6, 'month')
        .endOf('month')
    ],
    //'Last Year': [moment().subtract(1, 'years'), moment()],
    //'Search Entire dBase': [moment().subtract(5, 'years'), moment()]
  };


  callDirections: SelectItem[] = [
    { id: 1, name: 'Inbound' },
    { id: 2, name: 'Outbound' },
    { id: 3, name: 'Both' },
  ];
  selectedCallDirections: number[] = [3];//Default is all


  //Common cols and Rslt selected cols
  commonCols: SelectItem[] = [
    { id: 1, name: 'VQuad Call ID' },
    { id: 2, name: 'VQuad Device ID' },
    { id: 3, name: 'VQuad Event ID' },
  ];
  selectedCommonCols: number[] = [-1];
  commonMatchMode: string;
  commonValue: any = "";

  andOrs: SelectItem[] = [
    { id: 1, name: 'AND' },
    { id: 2, name: 'OR' },
  ];
  selectedAndOrs: number[] = [1];
  andOrVisible: boolean = false;

  results: SelectItem[] = [
    { id: 0, name: 'VQT PESQ', parentId: 'pesq', alias: 'VQTDATA' },
    { id: 1, name: 'VQT POLQA', parentId: 'polqa', alias: 'VQTPOLQA' },
    { id: 2, name: 'Audio/Delay', parentId: 'audio-delay', alias: 'VQUADDATA' },
    { id: 3, name: 'TCP', parentId: 'nettest', alias: 'TCPDATA' },
    { id: 4, name: 'UDP', parentId: 'nettest', alias: 'UDPDATA' },
    { id: 5, name: 'VOIP', parentId: 'nettest', alias: 'VOIPDATA' },
    { id: 6, name: 'ROUTE', parentId: 'nettest', alias: 'ROUTEDATA' },
    { id: 7, name: 'HTTP', parentId: 'nettest', alias: 'HTTPDATA' },
    { id: 8, name: 'FTP', parentId: 'nettest', alias: 'FTPDATA' },
    { id: 9, name: 'DNS', parentId: 'nettest', alias: 'DNSDATA' },
    { id: 10, name: 'SMS', parentId: 'nettest', alias: 'SMSDATA' },
    { id: 11, name: 'EMAIL', parentId: 'nettest', alias: 'EMAILDATA' },
    { id: 12, name: 'Phone Info', parentId: 'mobileinfo', alias: 'GENERALINFO' },
    { id: 13, name: 'SIM', parentId: 'mobileinfo', alias: 'SIMINFO' },
    { id: 14, name: 'UE', parentId: 'mobileinfo', alias: 'UEINFO' },
    //{ id: 15, name: 'EMU', parentId: 'emu', alias: 'EMUDATA' },
    //{ id: 16, name: 'FAX', parentId: 'fax', alias: 'FAXDATA' },
    { id: 17, name: 'EModule', parentId: 'vba', alias: 'EModule' },
    //{ id: 18, name: 'Connection Drop', parentId: 'conndrop', alias: 'CONNDROPDATA' },
    //{ id: 19, name: 'VAC', parentId: 'vac', alias: 'VACDATA' },
    { id: 20, name: 'VQuad Call Events', parentId: 'call-events', alias: 'VQUADDATA' },
  ];
  selectedResults: number[] = [0];

  mainCols: SelectItem[] = [];
  selectedMainCols: number[];
  mainMatchMode: string;
  mainValue: any = "";
  mainValueTo: any = "";

  commonAndResultsBoth: SelectItem[] = [
    { id: -1, name: 'VQuad Call ID', showSubUL: -1 },
    { id: -2, name: 'VQuad Device ID', showSubUL: -1 },
    { id: -3, name: 'VQuad Event ID', showSubUL: -1 },
    {
      id: 0, name: 'VQT', showSubUL: 1, children: [
        { id: 0, name: 'PESQ', parentId: 'pesq', alias: 'VQTDATA' },
        { id: 1, name: 'POLQA', parentId: 'polqa', alias: 'VQTPOLQA' },
      ]
    },
    { id: 20, name: 'VQuad Call Events', showSubUL: -1, parentId: 'call-events', alias: 'VQUADDATA' },//changed position from bottom to top but not ID
    { id: 2, name: 'Audio/Delay', showSubUL: -1, parentId: 'audio-delay', alias: 'VQUADDATA' },
    {
      id: 3, name: 'NetTest', showSubUL: 1, children: [
        { id: 3, name: 'TCP', parentId: 'nettest', alias: 'TCPDATA' },
        { id: 4, name: 'UDP', parentId: 'nettest', alias: 'UDPDATA' },
        { id: 5, name: 'VOIP', parentId: 'nettest', alias: 'VOIPDATA' },
        { id: 6, name: 'ROUTE', parentId: 'nettest', alias: 'ROUTEDATA' },
        { id: 7, name: 'HTTP', parentId: 'nettest', alias: 'HTTPDATA' },
        { id: 8, name: 'FTP', parentId: 'nettest', alias: 'FTPDATA' },
        { id: 9, name: 'DNS', parentId: 'nettest', alias: 'DNSDATA' },
        { id: 10, name: 'SMS', parentId: 'nettest', alias: 'SMSDATA' },
        { id: 11, name: 'EMAIL', parentId: 'nettest', alias: 'EMAILDATA' },
      ]
    },
    {
      id: 12, name: 'MobileInfo', showSubUL: 1, children: [
        { id: 12, name: 'Phone Info', parentId: 'mobileinfo', alias: 'GENERALINFO' },
        { id: 13, name: 'SIM', parentId: 'mobileinfo', alias: 'SIMINFO' },
        { id: 14, name: 'UE', parentId: 'mobileinfo', alias: 'UEINFO' },
      ]
    },
    //{ id: 15, name: 'EMU', parentId: 'emu', alias: 'EMUDATA' },
    //{ id: 16, name: 'FAX', parentId: 'fax', alias: 'FAXDATA' },
    { id: 17, name: 'EModule', showSubUL: -1, parentId: 'vba', alias: 'EModule' },
    //{ id: 18, name: 'Connection Drop', parentId: 'conndrop', alias: 'CONNDROPDATA' },
    //{ id: 19, name: 'VAC', parentId: 'vac', alias: 'VACDATA' },
  ];
  selectedCommonAndResultsCols: number[] = [-1];

  stringOperators: any[];
  rangeOperators: any[];
  selParamOperators: any[] = [];//based on param selected
  defaultStringMatchMode = FilterOperator.STARTS_WITH;
  defaultRangeMatchMode = FilterOperator.GREATER_THAN_OR_EQUAL;

  messages: DtMessages = new DtMessagesEn({});

  selRatingParamOperators: any[] = [
    //{ value: RatingOperator.NOTUSE, text: this.messages.notUse },
    { value: RatingOperator.LESS_THAN_OR_EQUAL, text: this.messages.lessThanOrEqual },
    { value: RatingOperator.EQUALS, text: this.messages.equals },
    { value: RatingOperator.GREATER_THAN_OR_EQUAL, text: this.messages.greaterThanOrEqual },
  ];

  mainRatingMatchMode: string;
  defaultRatingMatchMode = RatingOperator.LESS_THAN_OR_EQUAL;//RatingOperator.NOTUSE;

  PESQRating: SelectItem[] = [
    { id: 0, name: 'Poor' },
    { id: 1, name: 'Fair' },
    { id: 2, name: 'Good' },
    { id: 3, name: 'Excellent' }
  ];
  selectedPESQRating: number[] = [0];

  POLQARating: SelectItem[] = [
    { id: 0, name: 'Poor' },
    { id: 1, name: 'Fair' },
    { id: 2, name: 'Good' },
    { id: 3, name: 'Excellent' }
  ];
  selectedPOLQARating: number[] = [0];

  RTDRating: SelectItem[] = [
    { id: 0, name: 'Error' },
    { id: 1, name: 'Fail' },
    { id: 2, name: 'Pass' }
  ];
  selectedRTDRating: number[] = [0];

  MOSRating: SelectItem[] = [
    //{ id: 0, name: 'Not Use' },
    { id: 1, name: 'Pass' },
    { id: 2, name: 'Fail' }
  ];
  selectedMOSRating: number[] = [1];

  private dataFilter: DataFilter;
  AutoRefreshInfo: any;
  constructor(private service: FiltersService, private regService: GoogleMapsService, private commonFilterService: CommonFilterService, private cdr: ChangeDetectorRef, private http: HttpClient, private demoService: DemoService) {
    this.dataFilter = new DataFilter();

    //Do Auto-refresh - start/stop
    this.commonFilterService.componentMethodWithArgCalled$.subscribe(

      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
      }
    );
    //this.selectedTime = { startDate: null, endDate: null }; //{ startDate: moment(), endDate: moment() };
    //this.selectedStartDateTime = null;
    //this.selectedEndDateTime = null;
    this.onClearClicked();
  }
  ngOnInit() {

    this.stringOperators = [
      { value: FilterOperator.STARTS_WITH, text: this.messages.startsWith },
      { value: FilterOperator.ENDS_WITH, text: this.messages.endsWith },
      { value: FilterOperator.CONTAINS, text: this.messages.contains },//2 - standard index for old webviewer data
      { value: FilterOperator.NOT_CONTAINS, text: this.messages.notContains },
      { value: FilterOperator.EQUALS, text: this.messages.equals },
      { value: FilterOperator.NOT_EQUAL, text: this.messages.notEqual },
      //{ value: FilterOperator.IS_EMPTY, text: this.messages.isEmpty },
      //{ value: FilterOperator.IS_NOT_EMPTY, text: this.messages.isNotEmpty },
    ];
    this.rangeOperators = [
      { value: FilterOperator.GREATER_THAN_OR_EQUAL, text: this.messages.greaterThanOrEqual },//0 - standard index for old webviewer data
      { value: FilterOperator.LESS_THAN_OR_EQUAL, text: this.messages.lessThanOrEqual },//1 - standard index for old webviewer data
      { value: FilterOperator.EQUALS, text: this.messages.equals },//2 - standard index for old webviewer data
      { value: FilterOperator.NOT_EQUAL, text: this.messages.notEqual },
      { value: FilterOperator.GREATER_THAN, text: this.messages.greaterThan },
      { value: FilterOperator.LESS_THAN, text: this.messages.lessThan },
      { value: FilterOperator.IN_RANGE, text: this.messages.inRange },
      //{ value: FilterOperator.IS_EMPTY, text: this.messages.isEmpty },
      //{ value: FilterOperator.IS_NOT_EMPTY, text: this.messages.isNotEmpty },
    ];
    this.selParamOperators = this.rangeOperators;

    this.onCommonAndResultsBothColsChange('-1');
    //this.getFilterConfig(0, '0');
    this.checkAuthorizeFilter("0");

  }

  checkAuthorizeFilter(filterID) {
    let authorrizeFilters;
    if (sessionStorage.getItem('SystemSettings')) {
      if (sessionStorage.getItem('SystemSettings') != null) {
        authorrizeFilters = JSON.parse(sessionStorage.getItem('SystemSettings')).authorizeFilters;
        if (authorrizeFilters) {
          if (authorrizeFilters != null) {
            if (authorrizeFilters != "") {
              this.authorizeCreateFilter = false;
              this.authorizeModifyFilter = false;
              this.authorizeDeleteFilter = false;
              for (let i = 0; i < authorrizeFilters.split(',').length; i++) {
                if (authorrizeFilters.split(',')[i] == 1) {
                  this.authorizeCreateFilter = true;
                }
                if (authorrizeFilters.split(',')[i] == 2) {
                  this.authorizeModifyFilter = true;
                }
                if (authorrizeFilters.split(',')[i] == 3) {
                  this.authorizeDeleteFilter = true;
                }

              }

              if (filterID != "0") {
                this.authorizeCreateFilter = this.authorizeModifyFilter == true ? true : false;
              }
            }
          }
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  onRegionChange(event) {
    let selID = parseInt(event);
    this.selectedRegions = [selID];
    this.cdr.detectChanges();
  }
  //reset region ddl to select again
  clearAllSelections($event): void {
    this.selectedRegions = [];
  }

  //onInputChange() { }
  //onInputFocus() { }
  //onInputBlur() { }

  isRangeFilter = false;
  critNeeded = true;
  onModeChange(type) {
    this.critNeeded = true;
    this.isRangeFilter = false;
    if (type == 0) {
      if (!this.isValueFilter && this.mainMatchMode == FilterOperator.IN_RANGE) {
        this.isRangeFilter = true;
      }
      else if (this.isValueFilter && (this.mainMatchMode == FilterOperator.IS_EMPTY || this.mainMatchMode == FilterOperator.IS_NOT_EMPTY)) {
        this.critNeeded = false;
      }
    }
    else if (type == 2)//Rating
      this.critNeeded = false;
    else {
      if (this.commonMatchMode == FilterOperator.IS_EMPTY || this.commonMatchMode == FilterOperator.IS_NOT_EMPTY) {
        this.critNeeded = false;
      }
    }
  }

  isValueFilter = false;
  onKeyPressFilterInput(event: KeyboardEvent) {
    if (event.which === Keys.ENTER) {
      //this.onClickOk();
    }
  }

  TZSelected = false;//"False";
  onTZSelectionChange(event): void {
    ////debugger
    if (event !== undefined && event !== null) {
      //https://flaviocopes.com/how-to-uppercase-first-letter-javascript/
      this.TZSelected = event.toString().charAt(0).toUpperCase() + event.toString().slice(1);
    }
  }

  FCSelected = false;//"False";
  onFCSelectionChange(event): void {
    ////debugger
    if (event !== undefined && event !== null) {
      this.FCSelected = event.toString().charAt(0).toUpperCase() + event.toString().slice(1);
    }
  }

  onCallDirectionsChange(event) {
    let selID = parseInt(event);
    if (isNaN(selID)) {
      selID = 3;
    }

    this.selectedCallDirections = [selID];
    //console.log(this.selectedCallDirections);
  }

  onCommonColsChange(event) {
    let selID = parseInt(event);
    this.selectedCommonCols = [selID];

    this.commonMatchMode = this.defaultStringMatchMode;
    if (this.selRow != "{}" && this.rowSelectionDone)
      this.commonMatchMode = this.stringOperators[parseInt(this.selRow["OperatorNum"])].value;
    this.onModeChange(1);

    this.commonValue = "";
    if (this.selRow != "{}" && this.rowSelectionDone)
      this.commonValue = this.selRow["Value"];

    if (this.rowSelectionDone)
      this.rowSelectionDone = false;
  }

  currCritListValue = ";";
  multiCritFunc(stringMatchMode, stringValue) {
    if (stringValue.trim().length > 0 || this.critNeeded == false || stringMatchMode == FilterOperator.IS_EMPTY || stringMatchMode == FilterOperator.IS_NOT_EMPTY) {
      if (stringMatchMode == FilterOperator.EQUALS || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.EQUALS))[1])
        this.currCritListValue += '*' + stringValue.trim() + '*';
      else if (stringMatchMode == FilterOperator.NOT_EQUAL || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.NOT_EQUAL))[1])
        this.currCritListValue += '^' + stringValue.trim() + '^';
      else if (stringMatchMode == FilterOperator.STARTS_WITH || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.STARTS_WITH))[1])
        this.currCritListValue += stringValue.trim() + '%';
      else if (stringMatchMode == FilterOperator.ENDS_WITH || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.ENDS_WITH))[1])
        this.currCritListValue += '%' + stringValue.trim();
      else if (stringMatchMode == FilterOperator.NOT_CONTAINS || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.NOT_CONTAINS))[1])
        this.currCritListValue += '!' + stringValue.trim() + '!';
      else if (stringMatchMode == FilterOperator.CONTAINS || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.CONTAINS))[1])
        this.currCritListValue += stringValue.trim();
      else if (stringMatchMode == FilterOperator.IS_EMPTY || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.IS_EMPTY))[1])//susheel
        this.currCritListValue += 'IS NULL';
      else if (stringMatchMode == FilterOperator.IS_NOT_EMPTY || stringMatchMode == (this.dataFilter.getOperatorType(FilterOperator.IS_NOT_EMPTY))[1])//susheel
        this.currCritListValue += 'IS NOT NULL';
    }
  }

  //savedCommonInternally = false;
  //RowsCommon = '';
  AddCritToCurrCommonParam() {
    this.validateCommonCriteria();
    if (this.critCommonErrors == true)
      return false;
    //console.log(this.selRow)
    if (this.selRow != "{}") {
      this.replaceAfterDel = true;
      this.onRowDeleted(this.selRow);
      this.replaceAfterDel = false;
    }

    this.multiCritFunc(this.commonMatchMode, this.commonValue);

    let colName = GetMapColumnAliia("VQuad_Location", "", "");
    if (this.selectedCommonCols[0] == -1) {
      if (this.mainFilter.VQuad_Location.length == 0)
        this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);
    }
    else if (this.selectedCommonCols[0] == -2) {
      colName = GetMapColumnAliia("VQuad_PhoneID", "", "");
      if (this.mainFilter.VQuad_PhoneID.length == 0)
        this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);
    }
    else if (this.selectedCommonCols[0] == -3) {
      colName = GetMapColumnAliia("VQuad_CallID", "", "");
      if (this.mainFilter.VQuad_CallID.length == 0)
        this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);
    }
    //console.log(this.mainFilter.VQuad_Location)
    this.ReloadSelMultiCriteria(this.currCritListValue.replace(';', ''));

    //this.Rows = '';
    if (this.Rows.length > 0)
      this.Rows = this.Rows.substring(1, this.Rows.length - 1) + ',';//remove [ and ] 

    let row = '';
    this.operAndCritList.every((eachOperAndCrit, i) => {
      ////debugger
      let operatorNum = this.stringOperators.findIndex((x) => x.value == eachOperAndCrit.oper);
      row = '{"Column_Name":"' + colName + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal + '","AndOr":"OR"}';
      if (this.Rows.indexOf(row) != -1) {
        alert('Already exists!')
        return false;
      }
      if (this.selectedCommonCols[0] == -1)
        this.mainFilter.VQuad_Location += this.currCritListValue;
      else if (this.selectedCommonCols[0] == -2)
        this.mainFilter.VQuad_PhoneID += this.currCritListValue;
      else if (this.selectedCommonCols[0] == -3)
        this.mainFilter.VQuad_CallID += this.currCritListValue;

      this.Rows += row + ',';
      return true;
    });
    //console.log(this.Rows)
    this.currCritListValue = ";";//reset

    if (this.Rows.length > 0)
      this.Rows = '[' + this.Rows.substring(0, this.Rows.length - 1) + ']';

    this.setRowsLatest();//refresh to latest ordered list unselecting row

    //setTimeout(() => {
    //  if (this.dataManager) {
    //    let colName = this.mainCols.find(x => x.id == this.selectedMainCols[0]).name;
    //    let tableRowIndx = -1;
    //    this.dataManager.rows.every((x, i) => {
    //      if (JSON.stringify(x.$$data).indexOf(row.substring(1, row.length - 1)) !== -1) {
    //        tableRowIndx = i;
    //        return false;
    //      }
    //      return true;
    //    })

    //    //let tableRowIndx = this.dataManager.rows.findIndex(x => x.Column_Name == colName);
    //    if (tableRowIndx != -1) {
    //      this.dataManager.selectRow(tableRowIndx);//AutoSelect row of the saved table, when a saved column selected in the columns list - IMP
    //    }
    //  }

    //  this.savedInternally = false;
    //}, 2000)
  }

  AddCritToCurrCommonAndMainParam() {
    if (this.isCommonOrMain)
      this.AddCritToCurrCommonParam();
    else
      this.AddCritToCurrRslt();
  }

  ResetCritOfCurrCommonParam() {

  }

  //selectedConfigCommon: boolean = false;

  async getSelRsltColsList(alias, parentId) {
    let DDLOrGrid = parentId == "emu" ? "DDL" : "Grid";

    //added Call Condition field as well
    let alphaNumSet = ";Target_Server;Phone_Model;Network_Type;TN_Number;TestStatus;Trace_from_IP;Trace_to_IP;Method;Query_Name;App_Version;Phone_IOS_Version;IMEI;SimMNC;SimMCC;IMSI;EGCI;PLMN_ID;Cell_ID;Neighbouring_Cell_ID;LAI;IpAddress;Gateway;DNS_UE;" +
      "VBA_Rating;Degraded;Deg_File_Name;Inventory;PAMSDelay_Per_Utterance;PESQDelay_Per_Utterance;PESQ_Per_Utterance;Rating;Reference;User_ID;Pass_Or_Fail;RTD_Error;RTD_Rating;Call_Control_Event;CC_Condition;Called_Number;Fax_Error;Fax_Event;Modem;Encoding;Resolution;ECM;Double_Talk;Ring_Type;Speech_Analysis;Dropout;VMWI;Equilibrium_Efficiency;Capacity_Efficiency;RTT_Consistency;Buffer_Delay;Error_Delay;Quality;";
    let nonButNumSet = ";Battery_Level;RSSI;Starting_Speed;Final_Speed;";//In DB, they are varchar type but actually are NUMBER type  

    let DAQOrNot = false;
    if (alias == 'VQTDATA') {
      await this.demoService.getVqtDAQSetting('VqtData').then(res => {
        DAQOrNot = res;
      });
    }

    this.http.get<any[]>('assets/ng-crud-table/DBTableSchemaFilters.json').subscribe(data => {
      let filtered = data.filter(cols => {
        if (cols.TABLE_NAME === alias && cols.COLUMN_NAME !== "ID" &&
          (((cols.DATA_TYPE === "NUMBER" || cols.DATA_TYPE === "FLOAT")
            && this.selectedResults[0] != 20)
            || (cols.COLUMN_NAME == "RTD_Rating" && this.selectedResults[0] == 2)
            || (alphaNumSet.indexOf(';' + cols.COLUMN_NAME + ';') != -1 && cols.COLUMN_NAME != "RTD_Rating" && this.selectedResults[0] != 2) || nonButNumSet.indexOf(';' + cols.COLUMN_NAME + ';') != -1)) {
          if (alias == 'VQTDATA' && cols.COLUMN_NAME === "DAQ" && !DAQOrNot)
            return false;

          return true;
        }

        return false;
      }).map(cols => ({ colName: cols.COLUMN_NAME, colType: cols.DATA_TYPE }));// - Add paranthesis before flower brackets - IMP
      //https://stackoverflow.com/questions/55608806/how-to-map-multiple-properties-to-arrays-in-angular-6

      this.mainCols = [];
      //console.log(filtered)
      filtered.forEach((x, i) => {
        this.mainCols.push({ id: i, name: GetMapColumnAliia(x.colName, parentId, DDLOrGrid), alias: x.colType, origName: x.colName });
      });
      if (this.selRow != "{}" && this.rowSelectionDone) {
        let rsltDetails = this.results.find(x => x.id === this.selectedResults[0]);
        if (rsltDetails) {
          if (rsltDetails.name == this.selRow['Result_Type']) {
            const colId = this.mainCols.find(x => x.name == this.selRow['Column_Name']);
            if (colId)
              this.onColsSelectionChange('' + colId.id);
          }
          else {
            this.selectedMainCols = [0];
            this.onColsSelectionChange('0');
          }
        }
        else {
          this.selectedMainCols = [0];
          this.onColsSelectionChange('0');
        }
      }
      else {
        this.selectedMainCols = [0];
        this.onColsSelectionChange('0');
      }

      if (this.rowSelectionDone)
        this.rowSelectionDone = false;
      //setTimeout(() => {
      //  if (this.dataManager) {
      //    let colName = this.mainCols.find(x => x.id == this.selectedMainCols[0]).name;
      //    let tableRowIndx = this.dataManager.rows.findIndex(x => x.Column_Name == colName);
      //    if (tableRowIndx != -1) {
      //      this.dataManager.selectRow(tableRowIndx);//AutoSelect row of the saved table, when a saved column selected in the columns list - IMP
      //    }
      //  }
      //}, 1000)
    });



    //this.columns = getColumnsHeaders(alias, parentId).filter(function (col) {
    //  return col.tableHidden === false;
    //});
    ////https://stackoverflow.com/questions/8900732/sort-objects-in-an-array-alphabetically-on-one-property-of-the-array
    //this.columns.sort(function (a, b) {
    //  var textA = a.title.toUpperCase();
    //  var textB = b.title.toUpperCase();
    //  return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    //});
    ////console.log(this.columns);
  }
  colNameTbl = "";
  colNameTblOrig = "";
  async getCurrColType(alias, parentId, colName?, colIndex?) {
    let DDLOrGrid = parentId == "emu" ? "DDL" : "Grid";

    //added Call Condition field as well
    let alphaNumSet = ";Target_Server;Phone_Model;Network_Type;TN_Number;TestStatus;Trace_from_IP;Trace_to_IP;Method;Query_Name;App_Version;Phone_IOS_Version;IMEI;SimMNC;SimMCC;IMSI;EGCI;PLMN_ID;Cell_ID;Neighbouring_Cell_ID;LAI;IpAddress;Gateway;DNS_UE;" +
      "VBA_Rating;Degraded;Deg_File_Name;Inventory;PAMSDelay_Per_Utterance;PESQDelay_Per_Utterance;PESQ_Per_Utterance;Rating;Reference;User_ID;Pass_Or_Fail;RTD_Error;RTD_Rating;Call_Control_Event;CC_Condition;Called_Number;Fax_Error;Fax_Event;Modem;Encoding;Resolution;ECM;Double_Talk;Ring_Type;Speech_Analysis;Dropout;VMWI;Equilibrium_Efficiency;Capacity_Efficiency;RTT_Consistency;Buffer_Delay;Error_Delay;Quality;";
    let nonButNumSet = ";Battery_Level;RSSI;Starting_Speed;Final_Speed;";//In DB, they are varchar type but actually are NUMBER type  

    let DAQOrNot = false;
    if (alias == 'VQTDATA') {
      await this.demoService.getVqtDAQSetting('VqtData').then(res => {
        DAQOrNot = res;
      });
    }

    let numeric = true;
    return await this.http.get<any[]>('assets/ng-crud-table/DBTableSchemaFilters.json').toPromise().then(data => {
      let filtered = data.filter(cols => {
        if (cols.TABLE_NAME === alias && cols.COLUMN_NAME !== "ID" &&
          (((cols.DATA_TYPE === "NUMBER" || cols.DATA_TYPE === "FLOAT")
            && this.selectedResults[0] != 20)
            || (cols.COLUMN_NAME == "RTD_Rating" && this.selectedResults[0] == 2)
            || (alphaNumSet.indexOf(';' + cols.COLUMN_NAME + ';') != -1 && cols.COLUMN_NAME != "RTD_Rating" && this.selectedResults[0] != 2) || nonButNumSet.indexOf(';' + cols.COLUMN_NAME + ';') != -1)) {
          if (alias == 'VQTDATA' && cols.COLUMN_NAME === "DAQ" && !DAQOrNot)
            return false;

          return true;
        }

        return false;
      }).map(cols => ({ colName: cols.COLUMN_NAME, colType: cols.DATA_TYPE }));// - Add paranthesis before flower brackets - IMP
      //https://stackoverflow.com/questions/55608806/how-to-map-multiple-properties-to-arrays-in-angular-6
      if (colName)
        numeric = filtered.find((x, i) => x.colName == colName).colType.indexOf('VARCHAR') !== -1 ? false : true;
      else if (colIndex) {
        let colItem = filtered.find((x, i) => i == colIndex);
        numeric = colItem.colType.indexOf('VARCHAR') !== -1 ? false : true;
        if (nonButNumSet.indexOf(';' + colItem.colName + ';') != -1)
          numeric = true;
        this.colNameTblOrig = filtered.find((x, i) => i == colIndex).colName;
        this.colNameTbl = GetMapColumnAliia(filtered.find((x, i) => i == colIndex).colName, parentId, DDLOrGrid);
      }

      return numeric;

    }).catch(() => {
      return numeric;
    });
  }

  onRsltSelectionChange(event) {
    let selID = parseInt(event);
    this.selectedResults = [selID];
    let selRsltItem: SelectItem[] = this.results.filter(function (item) {
      return item.id === selID;
    });

    this.getSelRsltColsList(selRsltItem[0].alias, selRsltItem[0].parentId);
  }
  chkActualColName() {
  }
  onRsltSelectionCancel() {

  }

  isCommonOrMain = true;
  isCommonDisabled: boolean;
  isMainDisabled: boolean;
  onCommonAndResultsBothColsChange(event) {
    let selID = parseInt(event);
    this.selectedCommonAndResultsCols = [selID];
    if (selID < 0) {
      this.onCommonColsChange(event);
      this.isCommonOrMain = true;
    }
    else {
      this.isCommonOrMain = false;
      this.onRsltSelectionChange(event);
    }
  }


  onColsSelectionChange(event) {
    let selID = parseInt(event);
    this.selectedMainCols = [selID];
    this.setSelParamsOpersList();
    this.setCriteriaValue();
    this.onAndOrChange('1');
  }
  isRatingParam = false;
  isPESQRating = false;
  isPOLQARating = false;
  isRTDRating = false;
  isMOSRating = false;
  setSelParamsOpersList() {

    let currColItem = this.mainCols.find((x, i) => i === this.selectedMainCols[0]);
    if (currColItem) {

      if ((this.selectedResults[0] == 0 && currColItem.origName == "Rating") || (this.selectedResults[0] == 1 && currColItem.origName == "Pass_Or_Fail")
        || (this.selectedResults[0] == 2 && currColItem.origName == "RTD_Rating")
        || (this.selectedResults[0] == 17 && currColItem.origName == "VBA_Rating")) {
        this.isRatingParam = true;
        this.mainRatingMatchMode = this.defaultRatingMatchMode;
        if (this.selRow != "{}" && this.rowSelectionDone)
          this.mainRatingMatchMode = this.selRatingParamOperators[parseInt(this.selRow["OperatorNum"])].value;
        this.onModeChange(2);

        this.isPESQRating = false;
        this.isPOLQARating = false;
        this.isRTDRating = false;
        this.isMOSRating = false;

        //////to set select row rating value for rating column for respective result types //elumalai
        this.isValueFilter = true;
        let ratingValue = 0;

        if (this.selectedResults[0] == 0) {
          this.isPESQRating = true;
          if (this.selRow != "{}" && this.rowSelectionDone) {
            const PESQFound = this.PESQRating.find(x => x.name == this.selRow["Value"]);
            if (PESQFound)
              ratingValue = PESQFound.id;
          }
          this.onRatingsChange(ratingValue, 0);
        }
        else if (this.selectedResults[0] == 1) {
          this.isPOLQARating = true;
          if (this.selRow != "{}" && this.rowSelectionDone) {
            const POLQAFound = this.POLQARating.find(x => x.name == this.selRow["Value"]);
            if (POLQAFound)
              ratingValue = POLQAFound.id;
          }
          this.onRatingsChange(ratingValue, 3);
        }
        else if (this.selectedResults[0] == 2) {
          this.isRTDRating = true;
          if (this.selRow != "{}" && this.rowSelectionDone) {
            const RTDFound = this.RTDRating.find(x => x.name == this.selRow["Value"]);
            if (RTDFound)
              ratingValue = RTDFound.id;
          }
          this.onRatingsChange(ratingValue, 1);
        }
        else if (this.selectedResults[0] == 17) {
          this.isMOSRating = true;
          if (this.selRow != "{}" && this.rowSelectionDone) {
            const MOSFound = this.MOSRating.find(x => x.name == this.selRow["Value"]);
            if (MOSFound)
              ratingValue = MOSFound.id;
          }
          this.onRatingsChange(ratingValue, 2);
        }
      }
      else {
        this.isRatingParam = false;

        if (currColItem.alias.indexOf('VARCHAR') !== -1) {// && currColItem.origName != "Battery_Level" && currColItem.origName != "RSSI" && currColItem.origName != "Starting_Speed" && currColItem.origName != "Final_Speed") {
          this.selParamOperators = this.stringOperators;
          this.isValueFilter = true;
          this.mainMatchMode = this.defaultStringMatchMode;
          if (this.selRow != "{}" && this.rowSelectionDone)
            this.mainMatchMode = this.selParamOperators[parseInt(this.selRow["OperatorNum"])].value;
          this.onModeChange(0);
        }
        else {
          this.isRangeFilter = false;
          this.selParamOperators = this.rangeOperators;
          if ((this.selectedResults[0] == 2 && currColItem.origName != "RTD_Rating")
            || (this.selectedResults[0] >= 3 && this.selectedResults[0] <= 14)
            || this.selectedResults[0] == 17) {//IMP - restrict audio/delay, nettest and mobileinfo, vba params to range oper for now
            this.selParamOperators = [{ value: FilterOperator.IN_RANGE, text: this.messages.inRange }];
            this.isRangeFilter = true;
            this.mainMatchMode = FilterOperator.IN_RANGE;
          }
          else {
            this.mainMatchMode = this.defaultRangeMatchMode;
            if (this.selRow != "{}" && this.rowSelectionDone)
              this.mainMatchMode = this.selParamOperators[parseInt(this.selRow["OperatorNum"])].value;
          }

          this.isValueFilter = false;
          this.onModeChange(0);
        }
      }
    }
  }
  setCriteriaValue() {
    this.mainValue = "";
    this.mainValueTo = "";
    if (this.selRow != "{}" && this.rowSelectionDone) {
      this.mainValue = this.selRow["Value"];
      if (this.selRow["Value_To"])
        this.mainValueTo = this.selRow["Value_To"].replace('--', '');
    }
  }
  onColsSelectionCancel() {

  }

  onRatingsChange(event, type) {
    let selID = parseInt(event);
    if (type == 0)
      this.selectedPESQRating = [selID];
    else if (type == 3)
      this.selectedPOLQARating = [selID];
    else if (type == 1)
      this.selectedRTDRating = [selID];
    else if (type == 2)
      this.selectedMOSRating = [selID];
  }

  disableAndOr: boolean;
  onAndOrChange(event) {
    this.disableAndOr = false;
    let currColItem = this.mainCols.find((x, i) => i === this.selectedMainCols[0]);
    if (currColItem) {
      if (this.Rows.indexOf('{"Column_OrigName":"' + currColItem.origName + '",') != -1) {
        this.selectedAndOrs = [2];
        this.disableAndOr = true;
      }
    }

    if (!this.disableAndOr) {
      let selID = parseInt(event);
      this.selectedAndOrs = [selID];
    }
  }


  //All single fields of filters - ratings, ranges, timezone, etc
  mainFilter = new MAINFILTER();

  savedInternally = false;
  Rows = '';
  replaceAfterDel = false;
  AddCritToCurrRslt() {
    this.validateCriteria();
    if (this.critErrors == true || this.critValueToErrors == true)
      return false;

    if (this.selRow != "{}") {
      this.replaceAfterDel = true;
      this.onRowDeleted(this.selRow);
      this.replaceAfterDel = false;
    }

    let colDetails = this.mainCols.find(x => x.id == this.selectedMainCols[0]);
    if (colDetails) { }
    else
      return false;
    let operIndx = this.selParamOperators.findIndex(x => x.value === this.mainMatchMode);
    let andOrItem: SelectItem = this.andOrs.find(item => item.id === this.selectedAndOrs[0]);
    let andOrVal = andOrItem.name;

    let ratingOper = this.mainRatingMatchMode;
    let ratingVal = "";
    ////debugger
    if (this.selectedResults[0] == 0) {
      if (colDetails.origName == "PESQ_LQ" && this.mainMatchMode === FilterOperator.IN_RANGE) {
        if (this.mainFilter.PESQ_LQ_Range != '|') {
          alert('Already exists!');
          return false;
        }
        this.mainFilter.PESQ_LQ_Range = this.mainValue + "|" + this.mainValueTo;
      }
      else if (colDetails.origName == "Rating") {// && this.mainRatingMatchMode != RatingOperator.NOTUSE) {
        if (this.Rows.indexOf('"Column_OrigName":"' + colDetails.origName + '",') != -1) {
          alert('Already exists!')
          return false;
        }
        const rateOperIndx = Object.entries(RatingOperator).findIndex(([key, value]) => value === this.mainRatingMatchMode);
        this.mainFilter.PESQ_LQ_Rating = rateOperIndx + "|" + this.selectedPESQRating[0];//https://stackoverflow.com/a/62701678 //https://www.cloudhadoop.com/typescript-convert-string-enum/
        ratingVal = this.PESQRating.find(x => x.id == this.selectedPESQRating[0]).name;
      }
      else {
        //0
        //VQT@|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$Or|VQTData|duration_hangover|LIKE|2|Duration Hangover(s)$ - params after @ and delimited $
        //|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$ - AND/OR  |  Table name   |   Parameter name   |  operator(=/>/</LIKE) | value  |  Alias Param name $
        let paramCritExists = false;

        let currColData12 = "|VQTData|" + colDetails.origName + "|" + operIndx + "|" + this.mainValue + "|" + colDetails.name;
        if (this.mainMatchMode === FilterOperator.IN_RANGE)
          currColData12 = "|VQTData|" + colDetails.origName + "|" + operIndx + "|" + this.mainValue + ":" + this.mainValueTo + "|" + colDetails.name;

        if (this.mainFilter.CriteriaCondition.length == 0) {
          this.mainFilter.CriteriaCondition = "VQT@";
          andOrVal = "";
          if (this.isValueFilter)
            this.multiCritFunc(this.mainMatchMode, this.mainValue);
        }
        else {
          //andOrVal = "AND";
          if (this.isValueFilter) {
            this.multiCritFunc(this.mainMatchMode, this.mainValue);
            let currPESQVal = (this.mainFilter.CriteriaCondition.split('@'))[1].split('$');
            currPESQVal.every(eachPESQ => {
              if (eachPESQ.indexOf(currColData12) != -1) {
                paramCritExists = true;
                return false;
              }
              return true;
            });
          }
        }
        if (paramCritExists) {
          this.currCritListValue = ";";
          alert('Already exists!');
          return false;
        }
        let currColData = andOrVal + currColData12 + "$";
        this.mainFilter.CriteriaCondition += currColData;
      }
    }
    else if (this.selectedResults[0] == 1) {
      if (colDetails.origName == "POLQA_Score" && this.mainMatchMode === FilterOperator.IN_RANGE) {
        if (this.mainFilter.POLQA_Score_Range != '|') {
          alert('Already exists!');
          return false;
        }
        this.mainFilter.POLQA_Score_Range = this.mainValue + "|" + this.mainValueTo;
      }
      else if (colDetails.origName == "Pass_Or_Fail") {// && this.mainRatingMatchMode != RatingOperator.NOTUSE) {
        if (this.Rows.indexOf('"Column_OrigName":"' + colDetails.origName + '",') != -1) {
          alert('Already exists!')
          return false;
        }
        //console.log(this.mainRatingMatchMode)
        const rateOperIndx = Object.entries(RatingOperator).findIndex(([key, value]) => value === this.mainRatingMatchMode);
        //console.log(rateOperIndx)
        this.mainFilter.POLQA_Score_Rating = rateOperIndx + "|" + this.selectedPOLQARating[0];
        //console.log(this.mainFilter.POLQA_Score_Rating)
        const polqaFound = this.POLQARating.find(x => x.id == this.selectedPOLQARating[0]);
        if (polqaFound)
          ratingVal = polqaFound.name;
      }
      else {
        //1
        //VQTPOLQA@|VQTPOLQA|POLQA_Score|=|8|POLQA_Score$And|VQTPOLQA|EModel_Polqa|<|4|EModel (R-factor)$
        //same as above vqt
        let paramCritExists = false;

        let currColData12 = "|VQTPOLQA|" + colDetails.origName + "|" + operIndx + "|" + this.mainValue + "|" + colDetails.name;
        if (this.mainMatchMode === FilterOperator.IN_RANGE)
          currColData12 = "|VQTPOLQA|" + colDetails.origName + "|" + operIndx + "|" + this.mainValue + ":" + this.mainValueTo + "|" + colDetails.name;

        if (this.mainFilter.POLQACriteriaCondition.length == 0) {
          this.mainFilter.POLQACriteriaCondition = "VQTPOLQA@";
          andOrVal = "";
          if (this.isValueFilter)
            this.multiCritFunc(this.mainMatchMode, this.mainValue);
        }
        else {
          //andOrVal = "AND";
          if (this.isValueFilter) {
            this.multiCritFunc(this.mainMatchMode, this.mainValue);
            let currPOLQAVal = (this.mainFilter.POLQACriteriaCondition.split('@'))[1].split('$');
            currPOLQAVal.every(eachPOLQA => {
              if (eachPOLQA.indexOf(currColData12) != -1) {
                paramCritExists = true;
                return false;
              }
              return true;
            });
          }
        }
        if (paramCritExists) {
          this.currCritListValue = ";";
          alert('Already exists!');
          return false;
        }
        let currColData = andOrVal + currColData12 + "$";
        this.mainFilter.POLQACriteriaCondition += currColData;
      }
    }
    else if (this.selectedResults[0] == 2) {
      //2 - Audio/Delay
      if (colDetails.origName == "RTD" && this.mainMatchMode === FilterOperator.IN_RANGE) {
        if (this.mainFilter.RTD_Range != '|') {
          alert('Already exists!');
          return false;
        }
        this.mainFilter.RTD_Range = this.mainValue + "|" + this.mainValueTo;
      }
      else if (colDetails.origName == "OWD" && this.mainMatchMode === FilterOperator.IN_RANGE) {
        if (this.mainFilter.OWD_Range != '|') {
          alert('Already exists!');
          return false;
        }
        this.mainFilter.OWD_Range = this.mainValue + "|" + this.mainValueTo;
      }
      else if (colDetails.origName == "PDD" && this.mainMatchMode === FilterOperator.IN_RANGE) {
        if (this.mainFilter.PDD_Range != '|') {
          alert('Already exists!');
          return false;
        }
        this.mainFilter.PDD_Range = this.mainValue + "|" + this.mainValueTo;
      }
      else if (colDetails.origName == "SWR" && this.mainMatchMode === FilterOperator.IN_RANGE) {
        if (this.mainFilter.SNR_Range != '|') {
          alert('Already exists!');
          return false;
        }
        this.mainFilter.SNR_Range = this.mainValue + "|" + this.mainValueTo;
      }
      else if (colDetails.origName == "RTD_Rating") {// && this.mainRatingMatchMode != RatingOperator.NOTUSE) {
        if (this.Rows.indexOf('"Column_OrigName":"' + colDetails.origName + '",') != -1) {
          alert('Already exists!')
          return false;
        }
        const rateOperIndx = Object.entries(RatingOperator).findIndex(([key, value]) => value === this.mainRatingMatchMode);
        this.mainFilter.RTD_Rating = rateOperIndx + "|" + this.selectedRTDRating[0];
        const rtdFound = this.RTDRating.find(x => x.id == this.selectedRTDRating[0]);
        if (rtdFound)
          ratingVal = rtdFound.name;
      }
    }
    else if (this.selectedResults[0] >= 3 && this.selectedResults[0] <= 11) {
      //3-11
      //;;;;;;;; - nettest
      //AND$1:333@9^OR$9:999@1;AND$2:777@2;AND$3:444@2;;;;;;AND$6:766@2 - delimited by ; for each nettest rslt type

      //AND$1:333@9^OR$9:999@1 - delimited by ^ for each param under curr rslt
      //AND$1:333@9 - AND/OR   $   1(Low) : 333(High)   @   9(param index)
      //; as delimiter between rslt types

      //NOTE - replace ^ with & as it confilicts doenot contans ^..^
      let eachNetTestParamsList = this.mainFilter.NetTest.split(';');
      let currIndex = this.selectedResults[0] - 3;
      let currNetTestVal = eachNetTestParamsList[currIndex];//all params of a rslt type

      let rsltCritExists = true;
      if (currNetTestVal.length == 0)//no params under curr rslt
        rsltCritExists = false;

      if (this.isValueFilter) {//single or multi string values
        this.multiCritFunc(this.mainMatchMode, this.mainValue);

        let newCurrNetTestVal = "";
        if (rsltCritExists) {
          let paramExists = false;
          let critExists = false;
          currNetTestVal.split('&').forEach((eachParamCrit, i) => {
            if (eachParamCrit.indexOf('@' + colDetails.id) != -1) {//append new crit to existng param
              paramExists = true;
              let multiCritArr = ((eachParamCrit.split('$'))[1].split('@'))[0].split('#');
              multiCritArr.every(eachCrit => {
                if (eachCrit === this.currCritListValue.replace(';', '')) {
                  critExists = true;
                  return false;
                }
                return true;
              });
              if (!critExists) {
                if (i > 0)
                  newCurrNetTestVal += '&';
                newCurrNetTestVal += eachParamCrit.replace('@' + colDetails.id, this.currCritListValue.replace(';', '#') + '@' + colDetails.id);//using # as multi crit delim
              }
            }
            else {
              if (i > 0)
                newCurrNetTestVal += '&';
              newCurrNetTestVal += eachParamCrit;
            }
          });

          if (critExists) {
            this.currCritListValue = ";";
            alert('Already exists!');
            return false;
          }

          if (!paramExists)//param not exists, so add this new param criteria at the exitisting params end
          {
            this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);//removes ; as newly adding
            newCurrNetTestVal += '&' + andOrVal + '$' + this.currCritListValue + '@' + colDetails.id;
          }
        }
        else {//freshly adding rslt and its first crit
          this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);//removes ; as newly adding
          newCurrNetTestVal += andOrVal + '$' + this.currCritListValue + '@' + colDetails.id;
        }

        eachNetTestParamsList[currIndex] = newCurrNetTestVal;//replacing final value
        //this.currCritListValue = ";";
      }
      else if (this.isRangeFilter) {//low to high
        if (eachNetTestParamsList[currIndex].indexOf('@' + colDetails.id) != -1) {
          this.currCritListValue = ";";
          alert('Already exists!');
          return false;
        }

        if (rsltCritExists)
          eachNetTestParamsList[currIndex] += '&';
        eachNetTestParamsList[currIndex] += andOrVal + '$' + this.mainValue + ":" + this.mainValueTo + '@' + colDetails.id;
      }
      //else//number
      //  eachNetTestParamsList[currIndex] += this.mainMatchMode + "|" + this.mainValue;

      this.mainFilter.NetTest = "";
      eachNetTestParamsList.forEach(eachNetTest => {
        this.mainFilter.NetTest += eachNetTest + ";";
      })

      this.mainFilter.NetTest = this.mainFilter.NetTest.substring(0, this.mainFilter.NetTest.length - 1);
    }
    else if (this.selectedResults[0] >= 12 && this.selectedResults[0] <= 14) {
      //12-14
      //;; - mobileinfo
      //AND$1:1000@0;AND$3:3000@0;
      //; as delimiter between rslt types

      //NOTE - replace ^ with & as it confilicts doenot contans ^..^
      let eachMobInfoParamsList = this.mainFilter.Mobile.split(';');
      let currIndex = this.selectedResults[0] - 12;
      let currMobInfoVal = eachMobInfoParamsList[currIndex];//all params of a rslt type

      let rsltCritExists = true;
      if (currMobInfoVal.length == 0)//no params under curr rslt
        rsltCritExists = false;

      if (this.isValueFilter) {//single or multi string values
        this.multiCritFunc(this.mainMatchMode, this.mainValue);

        let newCurrMobInfoVal = "";
        if (rsltCritExists) {
          let paramExists = false;
          let critExists = false;
          currMobInfoVal.split('&').forEach((eachParamCrit, i) => {
            if (eachParamCrit.indexOf('@' + colDetails.id) != -1) {//append new crit to existng param
              paramExists = true;
              let multiCritArr = ((eachParamCrit.split('$'))[1].split('@'))[0].split('#');
              multiCritArr.every(eachCrit => {
                if (eachCrit === this.currCritListValue.replace(';', '')) {
                  critExists = true;
                  return false;
                }
                return true;
              });
              if (!critExists) {
                if (i > 0)
                  newCurrMobInfoVal += '&';
                newCurrMobInfoVal += eachParamCrit.replace('@' + colDetails.id, this.currCritListValue.replace(';', '#') + '@' + colDetails.id);//using # as multi crit delim
              }
            }
            else {
              if (i > 0)
                newCurrMobInfoVal += '&';
              newCurrMobInfoVal += eachParamCrit;
            }
          });

          if (critExists) {
            this.currCritListValue = ";";
            alert('Already exists!');
            return false;
          }

          if (!paramExists)//param not exists, so add this new param criteria at the exitisting params end, thus making multi
          {
            this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);//removes ; as newly adding
            newCurrMobInfoVal += '&' + andOrVal + '$' + this.currCritListValue + '@' + colDetails.id;
          }
        }
        else {
          this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);//removes ; as newly adding
          newCurrMobInfoVal += andOrVal + '$' + this.currCritListValue + '@' + colDetails.id;
        }

        eachMobInfoParamsList[currIndex] = newCurrMobInfoVal;//replacing final value
      }
      else if (this.isRangeFilter) {//low to high
        if (eachMobInfoParamsList[currIndex].indexOf('@' + colDetails.id) != -1) {
          this.currCritListValue = ";";
          alert('Already exists!');
          return false;
        }

        if (rsltCritExists)
          eachMobInfoParamsList[currIndex] += '&';
        eachMobInfoParamsList[currIndex] += andOrVal + '$' + this.mainValue + ":" + this.mainValueTo + '@' + colDetails.id;
      }
      //else//number
      //  eachMobInfoParamsList[currIndex] += this.mainMatchMode + "|" + this.mainValue;

      this.mainFilter.Mobile = "";
      eachMobInfoParamsList.forEach(eachMobInfo => {
        this.mainFilter.Mobile += eachMobInfo + ";";
      })

      this.mainFilter.Mobile = this.mainFilter.Mobile.substring(0, this.mainFilter.Mobile.length - 1);
    }
    else if (this.selectedResults[0] == 17) {
      //17 - Emodule
      if (colDetails.origName == "MOS_CQ" && this.mainMatchMode === FilterOperator.IN_RANGE) {
        if (this.mainFilter.MOSCQ_Range != '|') {
          alert('Already exists!');
          return false;
        }
        this.mainFilter.MOSCQ_Range = this.mainValue + "|" + this.mainValueTo;
      }
      else if (colDetails.origName == "VBA_Rating") {
        if (this.Rows.indexOf('"Column_OrigName":"' + colDetails.origName + '",') != -1) {
          alert('Already exists!')
          return false;
        }
        this.mainFilter.MOSCQ_Rating = "" + this.selectedMOSRating[0];
        ratingOper = this.selRatingParamOperators[1].value;//equals always
        const mosFound = this.MOSRating.find(x => x.id == this.selectedMOSRating[0]);
        if (mosFound)
          ratingVal = mosFound.name;
      }
    }
    else if (this.selectedResults[0] == 20) {
      //20 - Call events
      if (colDetails.origName == "CC_Condition")
        this.multiCritFunc(this.mainMatchMode, this.mainValue.replace(';', '~'));
      else
        this.multiCritFunc(this.mainMatchMode, this.mainValue);

      if (colDetails.origName == "Call_Control_Event") {
        if (this.mainFilter.Call_Control_Event.length == 0)
          this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);
        this.mainFilter.Call_Control_Event += this.currCritListValue;
      }
      else if (colDetails.origName == "CC_Condition") {
        if (this.mainFilter.CC_Condition.length == 0)
          this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);
        this.mainFilter.CC_Condition += this.currCritListValue;
      }
      else if (colDetails.origName == "Called_Number") {
        if (this.mainFilter.Called_Number.length == 0)
          this.currCritListValue = this.currCritListValue.substring(1, this.currCritListValue.length + 1);
        this.mainFilter.Called_Number += this.currCritListValue;
      }
    }

    let rsltDetails = this.results.find(x => x.id === this.selectedResults[0]);
    if (rsltDetails) { }
    else
      return false;
    let row = '';

    let colIndx = '';
    if (this.selectedResults[0] >= 3 && this.selectedResults[0] <= 14)
      colIndx = ',"Column_Index":"' + colDetails.id + '"';

    if (this.isValueFilter) {
      this.ReloadSelMultiCriteria(this.currCritListValue.replace(';', ''));
      //this.stringOperators.forEach(x => console.log((this.dataFilter.getOperatorType(x.value))[1]))
      this.operAndCritList.forEach((eachOperAndCrit, i) => {
        let newVal = colDetails.origName == "CC_Condition" ? eachOperAndCrit.critVal.replace('~', ';') : eachOperAndCrit.critVal;
        let operatorNum = this.stringOperators.findIndex((x) => x.value == eachOperAndCrit.oper);
        row = '{"Column_OrigName":"' + colDetails.origName + '","NumOrRatingOrStr":"3"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + colDetails.name + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + newVal + '","Value_To":"--","AndOr":"' + andOrVal + '"}';
      });
    }
    else if (this.isRatingParam) {
      //if ((colDetails.origName == "Rating" && this.mainFilter.PESQ_LQ_Rating.indexOf('0|') != -1) ||
      //  (colDetails.origName == "Pass_Or_Fail" && this.mainFilter.POLQA_Score_Rating.indexOf('0|') != -1) ||
      //  (colDetails.origName == "RTD_Rating" && this.mainFilter.RTD_Rating.indexOf('0|') != -1) ||
      //  (colDetails.origName == "VBA_Rating" && this.mainFilter.MOSCQ_Rating.indexOf('0|') != -1)) {
      //  //don't add to table as new row
      //}
      //else
      let operatorNum = this.selRatingParamOperators.findIndex((x) => x.value == ratingOper);//(this.dataFilter.getOperatorType(ratingOper))[0];
      //operatorNum = operatorNum == '0' ? operatorNum : (operatorNum == '3' ? '1' : '2');
      row = '{"Column_OrigName":"' + colDetails.origName + '","NumOrRatingOrStr":"2"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + colDetails.name + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(ratingOper))[1] + '","Value":"' + ratingVal + '","Value_To":"--","AndOr":"' + andOrVal + '"}';
    }
    else {
      let valueTo = this.isRangeFilter ? this.mainValueTo : "--";
      //if (this.isRangeFilter && this.mainValue.trim() == '' && this.mainValueTo.trim() == '') {
      //  //don't add to table as new row
      //}
      //else
      let operatorNum = this.rangeOperators.findIndex((x) => x.value == this.mainMatchMode);
      row = '{"Column_OrigName":"' + colDetails.origName + '","NumOrRatingOrStr":"1"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + colDetails.name + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(this.mainMatchMode))[1] + '","Value":"' + this.mainValue + '","Value_To":"' + valueTo + '","AndOr":"' + andOrVal + '"}';
    }
    this.currCritListValue = ";";//reset
    //console.log(this.Rows)
    //console.log((row.split('"AndOr":'))[0])
    //if (this.Rows.indexOf((row.split('"AndOr":'))[0]) != -1) {
    //  alert('Already exists!')
    //  return false;
    //}
    if (row.split('"AndOr":')[0] != '' && this.Rows.indexOf((row.split('"AndOr":'))[0]) != -1) {
      alert('Already exists!')
      return false;
    }
    this.selectedAndOrs = [2];
    this.disableAndOr = true;

    if (this.Rows.length > 0)
      this.Rows = this.Rows.substring(1, this.Rows.length - 1) + ',';//remove [ and ]
    this.Rows += row + ',';

    if (this.Rows.length > 0)
      this.Rows = '[' + this.Rows.substring(0, this.Rows.length - 1) + ']';

    this.setRowsLatest();

    //setTimeout(() => {
    //  if (this.dataManager) {
    //    let colName = this.mainCols.find(x => x.id == this.selectedMainCols[0]).name;
    //    let tableRowIndx = -1;
    //    this.dataManager.rows.every((x, i) => {
    //      if (JSON.stringify(x.$$data).indexOf(row.substring(1, row.length - 1)) !== -1) {
    //        tableRowIndx = i;
    //        return false;
    //      }
    //      return true;
    //    })

    //    //let tableRowIndx = this.dataManager.rows.findIndex(x => x.Column_Name == colName);
    //    if (tableRowIndx != -1) {
    //      this.dataManager.selectRow(tableRowIndx);//AutoSelect row of the saved table, when a saved column selected in the columns list - IMP
    //    }
    //  }

    //  this.savedInternally = false;
    //}, 2000)
  }
  //Loads latest saved param or selected table param as well loads table with fresh saved devids and params of sel rslt
  //delCrit = false;
  operAndCritList: any[] = [];
  ReloadSelMultiCriteria(commonOrMainCritVal, sep?) {
    this.operAndCritList = [];//reset

    //this.delCrit = false;
    if (commonOrMainCritVal !== "") {

      let currCritsArr = commonOrMainCritVal.split(sep);
      currCritsArr.forEach((eachOperAndCrit, i) => {
        let operAndCritObj = {};
        if (eachOperAndCrit.indexOf('*') == 0 && eachOperAndCrit.lastIndexOf('*') == eachOperAndCrit.length - 1) {
          operAndCritObj["oper"] = FilterOperator.EQUALS;
          operAndCritObj["critVal"] = eachOperAndCrit.substring(1, eachOperAndCrit.length - 1);
        }
        else if (eachOperAndCrit.indexOf('^') == 0 && eachOperAndCrit.lastIndexOf('^') == eachOperAndCrit.length - 1) {
          operAndCritObj["oper"] = FilterOperator.NOT_EQUAL;
          operAndCritObj["critVal"] = eachOperAndCrit.substring(1, eachOperAndCrit.length - 1);
        }
        else if (eachOperAndCrit.indexOf('%') != 0 && eachOperAndCrit.lastIndexOf('%') == eachOperAndCrit.length - 1) {
          operAndCritObj["oper"] = FilterOperator.STARTS_WITH;
          operAndCritObj["critVal"] = eachOperAndCrit.substring(0, eachOperAndCrit.length - 1);
        }
        else if (eachOperAndCrit.indexOf('%') == 0 && eachOperAndCrit.lastIndexOf('%') != eachOperAndCrit.length - 1) {
          operAndCritObj["oper"] = FilterOperator.ENDS_WITH;
          operAndCritObj["critVal"] = eachOperAndCrit.substring(1, eachOperAndCrit.length);
        }
        else if (eachOperAndCrit.indexOf('!') == 0 && eachOperAndCrit.lastIndexOf('!') == eachOperAndCrit.length - 1) {
          operAndCritObj["oper"] = FilterOperator.NOT_CONTAINS;
          operAndCritObj["critVal"] = eachOperAndCrit.substring(1, eachOperAndCrit.length - 1);
        }
        else if (eachOperAndCrit == 'IS NULL') {//susheel
          operAndCritObj["oper"] = FilterOperator.IS_EMPTY;
          operAndCritObj["critVal"] = eachOperAndCrit;
        }
        else if (eachOperAndCrit == 'IS NOT NULL') {
          operAndCritObj["oper"] = FilterOperator.IS_NOT_EMPTY;
          operAndCritObj["critVal"] = eachOperAndCrit;
        }
        else {
          operAndCritObj["oper"] = FilterOperator.CONTAINS;
          operAndCritObj["critVal"] = eachOperAndCrit;
        }
        this.operAndCritList.push(operAndCritObj);
      });
    }
  }

  selRow: any = '{}';
  rowSelectionDone: boolean = false;
  editCtrlsHighlight: boolean = false;
  ReloadCritToCurrRslt(row) {
    this.selRow = row;
    // let row = '{"Column_OrigName":"' + rsltAndParamList[1] + '","NumOrRatingOrStr":"2","Result_Type":"' + rsltDetails.name + '","Column_Name":"' + GetMapColumnAliia(rsltAndParamList[1], "", "") + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(ratingOper))[1] + '","Value":"' + ratingVal + '","Value_To":"--","AndOr":"' + andOrVal + '"}';
    let rsltId = '-1';
    if (row['Column_Name'] == "VQuad Call ID")
      rsltId = '-1';
    else if (row['Column_Name'] == "VQuad DeviceID")
      rsltId = '-2';
    else if (row['Column_Name'] == "VQuad EventID")
      rsltId = '-3';
    else {
      const rsltTypeFound = this.results.find(x => x.name == row['Result_Type']);
      if (rsltTypeFound)
        rsltId = rsltTypeFound.id;
    }

    this.rowSelectionDone = true;
    this.editCtrlsHighlight = true;
    this.onCommonAndResultsBothColsChange(rsltId);
  }
  //ResetCritOfCurrRslt() {
  //  this.critErrors = false;
  //}

  //Validations
  critCommonErrors: boolean = false;
  critCommonErrorDesc = "*Required";
  validateCommonCriteria() {
    this.critCommonErrors = false;
    ////debugger
    //when input empty
    if (this.commonValue.length === 0 && this.critNeeded == true) {
      this.critCommonErrors = true;
      this.critCommonErrorDesc = "*Required";
    }
    //else if (!this.isValueFilter) {//when input type is numeric and pasted alpha numeric
    //  if (isNaN(this.commonValue)) {
    //    this.critCommonErrors = true;
    //    this.critCommonErrorDesc = "*Invalid number";
    //  }
    //}
  }
  //Validations
  critErrors: boolean = false;
  critValueToErrors: boolean = false;
  critErrorDesc = "*Required";
  critValueToErrorDesc = "*Required";
  validateCriteria() {
    ////debugger
    this.critErrors = false;
    this.critValueToErrors = false;
    //when input empty
    if (this.mainValue.length === 0 && this.critNeeded == true) {
      this.critErrors = true;
      this.critErrorDesc = "*Required";

      if (this.isRangeFilter) {
        this.critValueToErrors = true;
        this.critValueToErrorDesc = "*Required";
      }
    }
    else if (!this.isValueFilter) {//when input type is numeric and pasted alpha numeric
      if (isNaN(this.mainValue)) {
        this.critErrors = true;
        this.critErrorDesc = "*Invalid number";
      }
      if (this.isRangeFilter) {
        if (isNaN(this.mainValueTo)) {
          this.critValueToErrors = true;
          this.critValueToErrorDesc = "*Invalid number";
        }
        else {
          //https://stackoverflow.com/questions/14667713/how-to-convert-a-string-to-number-in-typescript - IMP
          if (+this.mainValue >= +this.mainValueTo) {
            this.critValueToErrors = true;
            this.critValueToErrorDesc = "*Invalid range";
          }
        }
      }
    }
  }

  //critDateErrors: boolean = false;
  critDateErrorDesc = "*Invalid dates selection";
  //Save internal memory of all map types to DB finally under curr config
  saveConfigToDB() {
    //if (this.mainFilter.ID == 0) {
    //  this.filtersSave.emit(this.mainFilter);
    //  return false;
    //}
    debugger
    this.resetMsg();
    let configuredOrNot = false;
    const regFound = this.regions.find(x => x.id == this.selectedRegions[0]);
    if (regFound)
      this.mainFilter.MapRegion = this.selectedRegions.length > 0 ? regFound.name : "--Select Config--";
    else if (this.selectedRegions.length == 0)
      this.mainFilter.MapRegion = "--Select Config--";

    configuredOrNot = configuredOrNot ? configuredOrNot : this.mainFilter.MapRegion != "--Select Config--" && this.mainFilter.MapRegion != null;

    //this.critDateErrors = false;
    //if ((this.selectedTime.startDate == null && this.selectedTime.endDate != null) || (this.selectedTime.startDate == null && this.selectedTime.endDate != null))
    //  this.critDateErrors = true;
    if (this.selectedTime.startDate == null && this.selectedTime.endDate == null)
      this.mainFilter.CustomDateTime = ';';
    else {

      if (this.wrongDateRange) {
        alert('Invalid Dates range!!');
        return;
      }
      if (this.okOrClear) {
        alert('Dates range selected but not applied!!');
        return;
      }
      let startAndEndDates = this.selectedTime.startDate.format('YYYY/MM/DD HH:mm:ss') + ';' + this.selectedTime.endDate.format('YYYY/MM/DD HH:mm:ss');//this.dateInput.nativeElement.value
      this.mainFilter.CustomDateTime = startAndEndDates;
      configuredOrNot = true;
    }

    this.mainFilter.Timezone = this.TZSelected == false ? 'False' : 'True';
    configuredOrNot = configuredOrNot ? configuredOrNot : this.TZSelected;

    this.mainFilter.Failed_Calls = this.FCSelected == false ? 'False' : 'True';
    configuredOrNot = configuredOrNot ? configuredOrNot : this.FCSelected;
    this.mainFilter.Failed_Calls += "|" + this.selectedCallDirections[0];//New column (I/O) adjusted in Failed Calls column itself
    configuredOrNot = configuredOrNot ? configuredOrNot : this.selectedCallDirections[0] != 3;

    this.mainFilter.NetTest = this.mainFilter.NetTest.replace(/\&OR/g, '^OR').replace(/\&AND/g, '^AND');//reverting param spli & to orig ^
    configuredOrNot = configuredOrNot ? configuredOrNot : this.mainFilter.NetTest != ";;;;;;;;";
    this.mainFilter.Mobile = this.mainFilter.Mobile.replace(/\&OR/g, '^OR').replace(/\&AND/g, '^AND');//reverting param spli & to orig ^
    configuredOrNot = configuredOrNot ? configuredOrNot : this.mainFilter.Mobile != ";;";

    configuredOrNot = configuredOrNot ? configuredOrNot : this.selectedConfig;

    if (!configuredOrNot) {
      alert("Invalid filter creation, no configuration to save ?");
      return false;
    }

    this.mainFilter.ID = -1;

    if (sessionStorage.getItem('SystemSettings')) {
      if (sessionStorage.getItem('SystemSettings') != null) {
        this.LoggedinUserName = JSON.parse(sessionStorage.getItem('SystemSettings')).UserName;
      }
    }

    //console.log(this.mainFilter)
    this.filtersSave.emit(this.mainFilter);
  }
  @Output() filtersSave: EventEmitter<MAINFILTER> = new EventEmitter<MAINFILTER>();

  //resetCritErrors() {
  //  this.critErrors = false;
  //}

  //set curr config from DB and load on table
  async setConfigFromDB(rowFilter: MAINFILTER) {

    this.mainFilter = rowFilter;
    //debugger;
    //Dates ranges
    if (this.mainFilter.CustomDateTime != ';' && this.mainFilter.CustomDateTime != null) {
      //console.log(this.mainFilter.CustomDateTime)
      let splittedDates = this.mainFilter.CustomDateTime.split(';');
      this.selectedStartDateTime = { startDate: moment(new Date((splittedDates)[0])), endDate: moment(new Date((splittedDates)[0])) };
      this.selectedEndDateTime = { startDate: moment(new Date((splittedDates)[1])), endDate: moment(new Date((splittedDates)[1])) };

      this.selectedTime = { startDate: moment(new Date((splittedDates)[0])), endDate: moment(new Date((splittedDates)[1])) };

      this.onOKClicked();
    }
    else {
      //this.selectedStartDateTime = null;
      //this.selectedEndDateTime = null;
      this.onClearClicked();
    }

    //map region
    ////debugger
    //
    setTimeout(() => {
      if (this.mainFilter.MapRegion != '--Select Config--' && this.mainFilter.MapRegion != null) {
        let regId = this.regions.find(x => x.name == this.mainFilter.MapRegion);
        this.cdr.detectChanges();

        if (regId) {
          this.onRegionChange(regId.id);
          //this.selectedRegions = [regId.id];
        }
      }
      else
        this.selectedRegions = [0];
    }, 3000);
    this.cdr.detectChanges();
    //Failed Calls and Call Direction
    this.mainFilter.Failed_Calls = this.mainFilter.Failed_Calls == null ? 'False' : this.mainFilter.Failed_Calls;
    if (this.mainFilter.Failed_Calls.indexOf('|') != -1)
      this.mainFilter.Failed_Calls = this.mainFilter.Failed_Calls + '|3';//Add Call Direction
    //this.onFCSelectionChange((this.mainFilter.Failed_Calls.split('|'))[0]);
    this.FCSelected = (this.mainFilter.Failed_Calls.split('|'))[0] == 'False' ? false : true;
    this.onCallDirectionsChange((this.mainFilter.Failed_Calls.split('|'))[1]);

    //Auto Timezone
    //this.onTZSelectionChange(this.mainFilter.Timezone);
    this.mainFilter.Timezone = this.mainFilter.Timezone == null ? 'False' : this.mainFilter.Timezone;
    this.TZSelected = this.mainFilter.Timezone == 'False' ? false : true;

    this.setRowsLatest();
  }
  async setRowsLatest() {
    //Call ID, Device, ID and Event ID
    this.Rows = '';
    this.mainFilter.VQuad_Location = this.mainFilter.VQuad_Location == null ? "" : this.mainFilter.VQuad_Location;
    this.mainFilter.VQuad_PhoneID = this.mainFilter.VQuad_PhoneID == null ? "" : this.mainFilter.VQuad_PhoneID;
    this.mainFilter.VQuad_CallID = this.mainFilter.VQuad_CallID == null ? "" : this.mainFilter.VQuad_CallID;
    //let commonValObj = { "VQuad_Location": this.mainFilter.VQuad_Location, "VQuad_DeviceID": this.mainFilter.VQuad_PhoneID, "VQuad_EventID": this.mainFilter.VQuad_CallID };
    let commonValObj = { "VQuad_Call_ID": this.mainFilter.VQuad_Location, "VQuad_DeviceID": this.mainFilter.VQuad_PhoneID, "VQuad_EventID": this.mainFilter.VQuad_CallID };
    for (const key in commonValObj) {
      if (commonValObj[key] != null) {
        if (commonValObj[key].length > 0) {
          let commonValList = commonValObj[key].split(';');

          commonValList.forEach((eachCommonVal) => {
            this.ReloadSelMultiCriteria(eachCommonVal);
            this.operAndCritList.forEach((eachOperAndCrit, i) => {
              let operatorNum = this.stringOperators.findIndex((x) => x.value == eachOperAndCrit.oper);
              //let row = '{"Column_Name":"' + colName + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal + '","AndOr":"OR"}';
              let row = '{"Column_Name":"' + GetMapColumnAliia(key, "", "") + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal + '","AndOr":"OR"}';
              this.Rows += row + ',';
            });
          });
        }
      }
    }
    //if (this.Rows.length > 0)
    //  this.Rows = '[' + this.Rows.substring(0, this.Rows.length - 1) + ']';

    //this.setRsltType(this.Rows);//, 0);

    this.mainFilter.Call_Control_Event = this.mainFilter.Call_Control_Event == null ? "" : this.mainFilter.Call_Control_Event;
    this.mainFilter.CC_Condition = this.mainFilter.CC_Condition == null ? "" : this.mainFilter.CC_Condition;
    this.mainFilter.Called_Number = this.mainFilter.Called_Number == null ? "" : this.mainFilter.Called_Number;
    let ccEventValObj = { "Call_Control_Event": this.mainFilter.Call_Control_Event, "CC_Condition": this.mainFilter.CC_Condition, "Called_Number": this.mainFilter.Called_Number };
    for (const key in ccEventValObj) {
      if (ccEventValObj[key] != null) {
        if (ccEventValObj[key].length > 0) {
          let ccEventValList = ccEventValObj[key].split(';');

          ccEventValList.forEach((eachCCEventVal) => {
            this.ReloadSelMultiCriteria(eachCCEventVal);
            this.operAndCritList.forEach((eachOperAndCrit, i) => {
              let operatorNum = this.stringOperators.findIndex((x) => x.value == eachOperAndCrit.oper);
              let row = '{"Column_OrigName":"' + key + '","NumOrRatingOrStr":"3","Result_Type":"VQuad Call Events","Column_Name":"' + GetMapColumnAliia(key, "", "") + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal.replace('~', ';') + '","Value_To":"--","AndOr":"OR"}';
              this.Rows += row + ',';
            });
          });
        }
      }
    }

    ////Main results and params
    //this.Rows = '';//reset
    this.mainFilter.PESQ_LQ_Range = this.mainFilter.PESQ_LQ_Range == null ? "|" : this.mainFilter.PESQ_LQ_Range;
    this.mainFilter.POLQA_Score_Range = this.mainFilter.POLQA_Score_Range == null ? "|" : this.mainFilter.POLQA_Score_Range;
    this.mainFilter.MOSCQ_Range = this.mainFilter.MOSCQ_Range == null ? "|" : this.mainFilter.MOSCQ_Range;
    this.mainFilter.RTD_Range = this.mainFilter.RTD_Range == null ? "|" : this.mainFilter.RTD_Range;
    this.mainFilter.OWD_Range = this.mainFilter.OWD_Range == null ? "|" : this.mainFilter.OWD_Range;
    this.mainFilter.SNR_Range = this.mainFilter.SNR_Range == null ? "|" : this.mainFilter.SNR_Range;
    this.mainFilter.PDD_Range = this.mainFilter.PDD_Range == null ? "|" : this.mainFilter.PDD_Range;
    let rangeListObj = {
      "0|PESQ_LQ": this.mainFilter.PESQ_LQ_Range, "1|POLQA_Score": this.mainFilter.POLQA_Score_Range,
      "2|RTD": this.mainFilter.RTD_Range, "2|OWD": this.mainFilter.OWD_Range, "2|SWR": this.mainFilter.SNR_Range, "2|PDD": this.mainFilter.PDD_Range,
      "17|MOS_CQ": this.mainFilter.MOSCQ_Range
    };
    for (const key in rangeListObj) {
      if (rangeListObj[key] != null) {
        if (rangeListObj[key].length > 0 && rangeListObj[key].trim() != '|') {
          let rsltAndParamList = key.split('|');
          let rsltDetails = this.results.find(x => x.id === parseInt(rsltAndParamList[0]));
          if (rsltDetails) {
            let currRangeList = rangeListObj[key].split('|');
            let andOrVal = "AND";
            if (currRangeList.length == 3)
              andOrVal = currRangeList[2];
            let operatorNum = this.rangeOperators.findIndex((x) => x.value == FilterOperator.IN_RANGE);
            let row = '{"Column_OrigName":"' + rsltAndParamList[1] + '","NumOrRatingOrStr":"1","Result_Type":"' + rsltDetails.name + '","Column_Name":"' + GetMapColumnAliia(rsltAndParamList[1], "", "") + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1] + '","Value":"' + currRangeList[0] + '","Value_To":"' + currRangeList[1] + '","AndOr":"' + andOrVal + '"}';
            this.Rows += row + ',';
          }
        }
      }
    };

    this.mainFilter.PESQ_LQ_Rating = this.mainFilter.PESQ_LQ_Rating == null ? "0|0" : this.mainFilter.PESQ_LQ_Rating;
    this.mainFilter.POLQA_Score_Rating = this.mainFilter.POLQA_Score_Rating == null ? "0|0" : this.mainFilter.POLQA_Score_Rating;
    this.mainFilter.RTD_Rating = this.mainFilter.RTD_Rating == null ? "0|0" : this.mainFilter.RTD_Rating;
    this.mainFilter.MOSCQ_Rating = this.mainFilter.MOSCQ_Rating == null ? "0" : this.mainFilter.MOSCQ_Rating;
    let ratingListObj = { "0|Rating": this.mainFilter.PESQ_LQ_Rating, "1|Pass_Or_Fail": this.mainFilter.POLQA_Score_Rating, "2|RTD_Rating": this.mainFilter.RTD_Rating, "17|VBA_Rating": this.mainFilter.MOSCQ_Rating };
    for (const key in ratingListObj) {
      if (ratingListObj[key] != null) {
        if (ratingListObj[key].length > 0 && ratingListObj[key] != '0|0' && ratingListObj[key] != '0') {
          let rsltAndParamList = key.split('|');
          let rsltDetails = this.results.find(x => x.id === parseInt(rsltAndParamList[0]));
          if (rsltDetails) {
            let currRatingList = ratingListObj[key].split('|');
            const rateOperIndx = Object.entries(RatingOperator).find(([key, value], i) => i === parseInt(currRatingList[0]));
            let ratingOper = "";
            let ratingVal = "";
            let andOrRange = 3;

            if (rsltAndParamList[0] == "0") {
              ratingOper = rateOperIndx[1];//this.selRatingParamOperators[parseInt(currRatingList[0])].value;//Rating operator
              ratingVal = this.PESQRating.find(x => x.id == parseInt(currRatingList[1])).name;//value dropdown
            }
            else if (rsltAndParamList[0] == "1") {
              ratingOper = rateOperIndx[1];//this.selRatingParamOperators[parseInt(currRatingList[0])].value;//Rating operator
              ratingVal = this.POLQARating.find(x => x.id == parseInt(currRatingList[1])).name;//value dropdown
            }
            else if (rsltAndParamList[0] == "2") {
              ratingOper = rateOperIndx[1];//this.selRatingParamOperators[parseInt(currRatingList[0])].value;//Rating operator
              ratingVal = this.RTDRating.find(x => x.id == parseInt(currRatingList[1])).name;//value dropdown
            }
            else if (rsltAndParamList[0] == "17") {
              ratingOper = this.selRatingParamOperators[2].value;
              ratingVal = this.MOSRating.find(x => x.id == parseInt(currRatingList[0])).name;//value dropdown
              andOrRange = 2;
            }
            let andOrVal = "AND";
            if (currRatingList.length == andOrRange)
              andOrVal = currRatingList[2];

            //let operatorNum = (this.dataFilter.getOperatorType(ratingOper))[0];
            //operatorNum = operatorNum == '0' ? operatorNum : (operatorNum == '3' ? '1' : '2');
            let operatorNum = this.selRatingParamOperators.findIndex((x) => x.value == ratingOper);
            let row = '{"Column_OrigName":"' + rsltAndParamList[1] + '","NumOrRatingOrStr":"2","Result_Type":"' + rsltDetails.name + '","Column_Name":"' + GetMapColumnAliia(rsltAndParamList[1], "", "") + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(ratingOper))[1] + '","Value":"' + ratingVal + '","Value_To":"--","AndOr":"' + andOrVal + '"}';
            this.Rows += row + ',';
          }
        }
      }
    };

    //0, 1
    //VQT@|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$Or|VQTData|duration_hangover|LIKE|2|Duration Hangover(s)$ - params after @ and delimited $
    //|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$ - AND/OR  |  Table name   |   Parameter name   |  operator(=/>/</LIKE) | value  |  Alias Param name $
    this.mainFilter.CriteriaCondition = this.mainFilter.CriteriaCondition == null ? "" : this.mainFilter.CriteriaCondition;
    this.mainFilter.POLQACriteriaCondition = this.mainFilter.POLQACriteriaCondition == null ? "" : this.mainFilter.POLQACriteriaCondition;
    let critConditionsList = [this.mainFilter.CriteriaCondition, this.mainFilter.POLQACriteriaCondition];
    await Promise.all(critConditionsList.map(async (eachRsltCrit, i) => {
      //critConditionsList.forEach((eachRsltCrit, i) => {
      if (eachRsltCrit != null) {
        if (eachRsltCrit.length > 0) {
          let allParamsCrit = (eachRsltCrit.split('@'))[1];
          let colsList = allParamsCrit.substring(0, allParamsCrit.length - 1).split('$');// remove last $

          await Promise.all(colsList.map(async eachCol => {
            //colsList.forEach(async eachCol => {
            let colDetailsList = eachCol.split('|');
            let rsltDetails = this.results.find(x => x.id === i);//0, 1
            if (rsltDetails) {
              let oper = FilterOperator.EQUALS;
              let operatorNum = this.rangeOperators.findIndex((x) => x.value == FilterOperator.EQUALS);
              let operType = 1;
              let value = colDetailsList[4];
              let valueTo = "--";
              if (isNaN(Number(colDetailsList[3]))) {
                if (colDetailsList[3] == ">") {
                  oper = FilterOperator.GREATER_THAN;
                  operatorNum = this.rangeOperators.findIndex((x) => x.value == FilterOperator.GREATER_THAN);
                }
                else if (colDetailsList[3] == "<") {
                  oper = FilterOperator.LESS_THAN;
                  operatorNum = this.rangeOperators.findIndex((x) => x.value == FilterOperator.LESS_THAN);
                }
                else if (colDetailsList[3] == "LIKE") {
                  oper = FilterOperator.CONTAINS;
                  operatorNum = this.stringOperators.findIndex((x) => x.value == FilterOperator.CONTAINS);
                }
              }
              else {
                let numericOrNot = await this.getCurrColType(rsltDetails.alias, rsltDetails.parentId, colDetailsList[2]);
                operType = numericOrNot == true ? 1 : 3;
                ////debugger
                oper = numericOrNot == true ? this.rangeOperators.find((x, i) => i == parseInt(colDetailsList[3])).value : this.stringOperators.find((x, i) => i == parseInt(colDetailsList[3])).value;
                operatorNum = numericOrNot == true ? parseInt(colDetailsList[3]) : this.stringOperators.findIndex((x) => x.value == oper);

                //console.log(oper + numericOrNot + colDetailsList[3])
                if (oper == FilterOperator.IN_RANGE) {
                  //if (operatorNum == this.rangeOperators.findIndex((x) => x.value == FilterOperator.IN_RANGE)) {
                  value = (colDetailsList[4].split(':'))[0];
                  valueTo = (colDetailsList[4].split(':'))[1];
                }
              }
              let row = '{"Column_OrigName":"' + colDetailsList[2] + '","NumOrRatingOrStr":"' + operType + '","Result_Type":"' + rsltDetails.name + '","Column_Name":"' + colDetailsList[5] + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(oper))[1] + '","Value":"' + value + '","Value_To":"' + valueTo + '","AndOr":"' + colDetailsList[0] + '"}';
              this.Rows += row + ',';
            }
          }));
        }
      }
    }));

    //3-11
    //;;;;;;;; - nettest
    //AND$1:333@9^OR$9:999@1;AND$2:777@2;AND$3:444@2;;;;;;AND$6:766@2 - delimited by ; for each nettest rslt type

    //AND$1:333@9^OR$9:999@1 - delimited by ^ for each param under curr rslt
    //AND$1:333@9 - AND/OR   $   1(Low) : 333(High)   @   9(param index)
    //; as delimiter between rslt types

    this.mainFilter.NetTest = this.mainFilter.NetTest == null ? ";;;;;;;;" : this.mainFilter.NetTest;
    this.mainFilter.Mobile = this.mainFilter.Mobile == null ? ";;" : this.mainFilter.Mobile;
    let netAndMobList = [this.mainFilter.NetTest, this.mainFilter.Mobile];
    let prevLength = 3;//From TCP
    await Promise.all(netAndMobList.map(async (eachRsltCrit, i) => {
      //netAndMobList.forEach(async (eachRsltCrit, i) => {
      if (eachRsltCrit != null) {
        if (eachRsltCrit.length > 0) {
          let currRsltList = eachRsltCrit.split(';');
          if (i == 1)
            prevLength = 12;//From PHONEINFO

          await Promise.all(currRsltList.map(async (eachsubrslt, j) => {
            //currRsltList.forEach(async (eachsubrslt, j) => {
            let rsltDetails = this.results.find(x => x.id === (j + prevLength));
            if (rsltDetails && eachsubrslt.length > 0) {
              let colsList = eachsubrslt.replace(/\^OR/g, '&OR').replace(/\^AND/g, '&AND').split('&');//To avoid confict of param split with doesnot contain operator

              //https://stackoverflow.com/questions/37576685/using-async-await-with-a-foreach-loop - IMP IMP
              await Promise.all(colsList.map(async eachCol => {
                //colsList.forEach(async eachCol => {
                let andOrCritList = (eachCol.split('@'))[0].split('$');
                let colIndx = ',"Column_Index":"' + (eachCol.split('@'))[1] + '"';
                let numericOrNot = await this.getCurrColType(rsltDetails.alias, rsltDetails.parentId, undefined, (eachCol.split('@'))[1]);
                if (numericOrNot == false) {

                  this.ReloadSelMultiCriteria(andOrCritList[1], '#');
                  this.operAndCritList.forEach((eachOperAndCrit, i) => {
                    let operatorNum = this.stringOperators.findIndex((x) => x.value == eachOperAndCrit.oper);
                    let row = '{"Column_OrigName":"' + this.colNameTblOrig + '","NumOrRatingOrStr":"3"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + this.colNameTbl + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal + '","AndOr":"OR"}';
                    this.Rows += row + ',';
                  });
                }
                else {
                  let operatorNum = this.rangeOperators.findIndex((x) => x.value == FilterOperator.IN_RANGE);
                  let row = '{"Column_OrigName":"' + this.colNameTblOrig + '","NumOrRatingOrStr":"1"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + this.colNameTbl + '","OperatorNum":"' + operatorNum + '","Operator":"' + (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1] + '","Value":"' + (andOrCritList[1].split(':'))[0] + '","Value_To":"' + (andOrCritList[1].split(':'))[1] + '","AndOr":"' + andOrCritList[0] + '"}';
                  this.Rows += row + ',';
                }
              }));
            }
          }));
        }
      }
    }));
    this.colNameTbl = "";
    this.colNameTblOrig = "";

    if (this.Rows.length > 0)
      this.Rows = '[' + this.Rows.substring(0, this.Rows.length - 1) + ']';

    this.setRsltType(this.Rows);//, 0);

    this.onCommonAndResultsBothColsChange('-1');//reset controls
    this.editCtrlsHighlight = false;
  }
  resetConfigFromDB() {
    this.mainFilter = new MAINFILTER();
    this.TZSelected = false;//"False";
    this.FCSelected = false;//"False";
    this.selectedCallDirections = [3];

    //this.selectedStartDateTime = null;
    //this.selectedEndDateTime = null;
    this.onClearClicked();
    //this.RowsCommon = '';
    this.Rows = '';
    //this.setRsltType(this.RowsCommon, 0);
    this.setRsltType(this.Rows);//, 1);
  }
  //del curr config from DB
  delConfigFromDB() {
    this.resetMsg();
    let r = confirm("Delete Configuration ?");
    if (r == false)
      return false;

    this.deleteFilterConfig(this.filterIDSelected);
  }

  @Output() filtersList: EventEmitter<SelectItem[]> = new EventEmitter<SelectItem[]>();
  filterIDSelected = 0;
  filterChanged = 0;
  async getFilterConfig(type: number, FilterID: string) {
    //////debugger;
    let filterNames: SelectItem[] = [];
    this.checkAuthorizeFilter(FilterID);

    if (type == 0) {
      filterNames.push({ id: undefined, name: '--Create New--' });
      return await this.service.getConfigsList(type, FilterID).toPromise().then((res) => {
        //https://stackoverflow.com/questions/53275405/typeerror-data-foreach-is-not-a-function/53275463 - JSON.parse - IMP
        //const rows: any[] = JSON.parse(res) as any[] || [];
        let rows: any[] = JSON.parse(res) as any[] || [];
        ////////// check if user previlege configed any mainfilter or not
        if (sessionStorage.getItem('SystemSettings')) {
          if (sessionStorage.getItem('SystemSettings') != null && JSON.parse(sessionStorage.getItem('SystemSettings')).mainFilterIDs != '') {
            let userConfigMainFilterIDs = JSON.parse(sessionStorage.getItem('SystemSettings')).mainFilterIDs.split(';');
            if (userConfigMainFilterIDs != null && userConfigMainFilterIDs.length > 0) {
              //rows = rows.filter(m => userConfigMainFilterIDs.includes(m.ID));
              let filteredRows = [];
              userConfigMainFilterIDs.forEach(item => {
                let itemRow = rows.filter(m => m.ID == item);
                filteredRows.push(itemRow[0]);
              });
              if (filteredRows.length > 0) {
                rows = filteredRows;
              }
            }
          }
        }
        rows.forEach(row => {
          filterNames.push({ id: row.ID, name: row.CriteriaName });
        });
        //console.log(filterNames)
        //this.filtersList.emit(filterNames);
        //this.onRsltSelectionChange('0');
        this.getRegionConfig();
        this.onCommonAndResultsBothColsChange('-1');
        this.resetConfigFromDB();

        return filterNames;
      });//0 - binds configs on top, 1 - selected config details by its ID, 2 - Saved and fetched details immediately
    }
    else if (type == 1) {
      this.filterIDSelected = parseInt(FilterID);
      this.filterChanged++;
      return await this.service.getConfigsList(type, FilterID).toPromise().then((res) => {
        const rows: MAINFILTER[] = JSON.parse(res) as MAINFILTER[] || [];
        //console.log(rows)
        rows.every(row => {
          this.setConfigFromDB(row);
          return false;
        });

        //this.onRsltSelectionChange('0');
        this.onCommonAndResultsBothColsChange('-1');

        return filterNames;
      });
    }
    //return filterNames;
  }
  getRegionConfig() {
    this.regions = [];
    this.regService.getRegConfigsList(0, "", null).toPromise().then((res) => {
      const rows: [] = JSON.parse(res) as [] || [];
      rows.forEach((row, i) => {
        this.regions.push({ id: (i + 1), name: row });//all configs with array each index as ID instead of DB ID //row.CriteriaName
      });
      //console.log(this.regions)
    })
  }

  messageDesc: string = '';
  message: boolean;
  resetMsg() {
    this.message = false;
    this.messageDesc = '';
  }
  @Output() filtersChange: EventEmitter<number> = new EventEmitter<number>();
  insertFilterConfig(item) {
    this.message = true;
    item.CriteriaName = item.CriteriaName + '|' + this.LoggedinUserName;
    this.service.post(item, "InsertFiltersData").then((res) => {
      if (res == -1)
        this.messageDesc = "Error in saving data";
      else {
        /////// save newly generate mainfilter ID in sessionstorage
        if (this.LoggedinUserName != "admin") {
          this.UpdateSessionVariable(res, 'SAVE');
        }

        this.filtersChange.emit(res);
        this.messageDesc = "Saved successfully";
        this.commonFilterService.basicFilterRefresh(1);//refresh load fitlers ddl to add new filter
      }
    });
  }

  UpdateSessionVariable(mainFilterID, type) {
    ////JSON.parse(sessionStorage.getItem('SystemSettings')).mainFilterIDs.split(';')
    let userData = JSON.parse(sessionStorage.getItem('SystemSettings'));
    if (type == "SAVE") {
      userData.mainFilterIDs += ";" + mainFilterID;
      sessionStorage.setItem('SystemSettings', JSON.stringify(userData));
    }
    else {
      //// delete mainfilterid from sessionstorage
      let IDs = userData.mainFilterIDs.split(';')
      const filteredParts = IDs.filter(part => part !== mainFilterID.toString());
      // Join the parts back together with a semicolon
      userData.mainFilterIDs = filteredParts.join(';');

      sessionStorage.setItem('SystemSettings', JSON.stringify(userData));
    }

  }

  updateFilterConfig(item) {
    this.message = true;
    this.service.put(item, "UpdateFiltersData").then((res) => {
      if (res == -1)
        this.messageDesc = "Error in updating data";
      else {
        this.filtersChange.emit(res);
        this.messageDesc = "Updated successfully";
      }
    });
  }
  async deleteFilterConfig(configID) {    
    if (configID > 0) {
      let delCriteriaName = this.mainFilter.CriteriaName;
      let FilterUsed = false;
      if (sessionStorage.getItem('SystemSettings')) {
        if (sessionStorage.getItem('SystemSettings') != null) {
          this.LoggedinUserName = JSON.parse(sessionStorage.getItem('SystemSettings')).UserName;
        }
      }
      await this.service.GetData_Service('/api/UserHierarchy/CheckUserHierarachyByFilterName?filterID=' + configID + '&LoggedinUserName=' + this.LoggedinUserName).toPromise().then((res: any) => {
        //console.log(res);
        let rows: any = JSON.parse(res) as any[];
        //////debugger;
        if (rows == "1") {
          FilterUsed = true;
        }
      });

      if (!FilterUsed) {
        await this.service.GetData_Service('/api/SchedulerReport/CheckSchNameByFilterName?filterName=' + delCriteriaName).toPromise().then((res: any) => {
          //console.log(res);
          let rows: any = JSON.parse(res) as any[];
          //////debugger;
          if (rows == "1") {
            FilterUsed = true;
          }
        });
      }
      //console.log(FilterUsed)
      debugger;
      if (FilterUsed) {
        let r = confirm("Filter already in use by other configurations. Do you want to proceed deleting everywhere?");
        if (r == false)
          return;
        //alert("Filter already in use and cannot be deleted.");
        //return;
      }
    }
    this.message = true;
    ////debugger;
    this.service.delete(configID + ',' + this.LoggedinUserName, "DeleteFiltersData").then((res) => {
      if (res == -1)
        this.messageDesc = "Error in deleting record";
      else {
        //this.getFilterConfig(0, '0');
        /////// remove mainfilter ID in sessionstorage  after mainfilter is deleted from mainfilter table
        if (this.LoggedinUserName != "admin") {
          this.UpdateSessionVariable(configID, 'DELETE');
        }

        this.filtersChange.emit(null);
        this.messageDesc = "Deleted successfully";

        if (this.filterChanged == 1)
          this.commonFilterService.basicFilterRefresh(3);//refresh load filters ddl to delete filter and turn off it
        else
          this.commonFilterService.basicFilterRefresh(1);//refresh ddl to delete filter
      }
    });
  }



  selectedConfig: boolean = false;
  //columnsCommon: Column[];
  columns: Column[];
  //dataManagerCommon: DataManager;
  dataManager: DataManager;
  settings: CdtSettings = new CdtSettings({
    crud: false,//create button toggle used to create dynamic row from columns set - IMP
    bodyHeight: 200,
    //headerRowHeight: 10,
    rowHeight: 20,
    exportAction: false,
    exportKMLAction: false,
    globalFilter: false,
    clickRows: false,
    columnToggleAction: false,
    clearAllFiltersAction: false,
    unshiftExpandIcon: false,//Toggle first dynamic column haing icon to show details view, update, etc as menu items - IMP
    unPopDelIcon: true,//Place Del icon at the end of each row thus creating a new column
    paginator: false,
  });

  setRsltType(Rows) {//, commonOrResults) {
    this.buildTable(Rows);//, commonOrResults);

    //if (commonOrResults == 0) {
    //  if (Rows == "")
    //    this.selectedConfigCommon = false;
    //  else
    //    this.selectedConfigCommon = true;
    //}
    //else {
    if (Rows == "")
      this.selectedConfig = false;
    else
      this.selectedConfig = true;
    //}

    //if (commonOrResults == 0) {
    //  this.columnsCommon = getConfigColumnsHeaders("filters");
    //  this.columnsCommon.forEach(col => col.width = 120);

    //  for (let i = 0; i < 4; i++)
    //    this.columnsCommon.shift();//remove first 4 cols till result_type
    //  this.columnsCommon.splice(3, 1);//remove value_to column
    //  //delete this.columnsCommon[3];//https://stackoverflow.com/questions/208105/remove-properties-from-objects-javascript

    //  this.columnsCommon.find(x => x.name === 'Column_Name').tableHidden = true;
    //  this.settings.groupRowsBy = ['Column_Name'];
    //  this.settings.groupRowsByTitles = ['Column Name'];
    //  this.settings.rowHeightProp = '$$height';

    //  this.dataManagerCommon = new DataManager(this.columnsCommon, this.settings, this.service, null, commonOrResults);
    //  this.dataManagerCommon.pager.perPage = Rows.length;
    //  this.dataManagerCommon.pager.pageSizeOptions = [];
    //}
    //else {
    this.columns = getConfigColumnsHeaders("filters");
    this.columns.forEach(col => { col.width = col.name == 'Operator' ? 180 : (col.name == 'Column_Name' ? 250 : 160); });

    //this.columns.find(x => x.name === 'Result_Type').tableHidden = true;
    //this.settings.groupRowsBy = ['Result_Type'];
    //this.settings.groupRowsByTitles = ['Result Type'];
    //this.settings.rowHeightProp = '$$height';

    ['Column_OrigName', 'NumOrRatingOrStr', 'OperatorNum', 'Column_Index'].forEach(eachCol => {
      const colFound = this.columns.find(x => x.name === eachCol);
      if (colFound)
        colFound.tableHidden = true;
    });
    if (this.columns.find(x => x.name === 'AndOr'))
      this.columns.find(x => x.name === 'AndOr').tableHidden = true;
    //console.log(this.columns)
    let MainFilterID = 0;
    this.commonFilterService.mainFilterID.subscribe(res => MainFilterID = res); /// set mainfilter selected ID - elumalai
    //let MainFilterTZ = 0;
    //this.commonFilterService.mfTZ.subscribe(res => MainFilterTZ = res); /// set mainfilter selected ID - elumalai

    let dbTz = -500;
    this.commonFilterService.DB_TZ.subscribe(res => {
      dbTz = res;
    });
    //if (dbTz == -500) {//query var col table
    //  await this.getDBTimezoneDiff(requestMeta.rsltType).then(res => {
    //    this.commonFilterService.setDBTZFromVarCol(res);
    //    dbTz = res;
    //  });
    //}

    let dbAndBrHrs = -500;
    //if (MainFilterID != 0) {
    this.commonFilterService.DB_BRDiff.subscribe(res => {
      dbAndBrHrs = res;
    });
    //}

    this.dataManager = new DataManager(this.columns, this.settings, this.service, dbTz, dbAndBrHrs, MainFilterID);//, null, commonOrResults);
    //this.dataManager = new DataManager(this.columns, this.settings, this.service, dbTz, dbAndBrHrs, MainFilterTZ);//, null, commonOrResults);
    const subSelection = this.dataManager.events.selectionSource$.subscribe(() => {
      this.rowSelected();
    });
    this.dataManager.dimensions.headerRowHeight = 0;//hides header row
    this.dataManager.pager.perPage = Rows.length;
    this.dataManager.pager.pageSizeOptions = [];
    //}
    ////console.log(this.dataManagerCommon)
    ////console.log(this.dataManager)
  }
  buildTable(Rows) {//, commonOrResults) {
    this.service.setRows(Rows);//, commonOrResults);
  }
  rowSelected(): void {
    this.isTableRowSelected = false;
    const selection = this.dataManager.selection.getSelection();
    //console.log(this.dataManager.rows)
    //https://github.com/mazdik/ng-mazdik/blob/master/src/app/demo/events-demo.component.ts
    const row = this.dataManager.rows[selection[0]];
    if (selection.length !== 0)
      this.isTableRowSelected = true;

    if (this.dataManager.rows.length > 0 && selection.length !== 0 && row) {
      this.ReloadCritToCurrRslt(row);
    }

  }
  onRowCommonDeleted($event) {
    ////debugger
    if (!this.replaceAfterDel) {
      let r = confirm("Delete row ?");
      if (r == false)
        return false;
    }

    //this.dataManager.selectRow($event.$$index);
    //let row = '{"Column_Name":"' + colName + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal + '","AndOr":"OR"}';
    let row = '{"Column_Name":"' + $event.Column_Name + '","OperatorNum":"' + $event.OperatorNum + '","Operator":"' + $event.Operator + '","Value":"' + $event.Value + '","AndOr":"OR"}';
    //const rowIndex = this.dataManager.rows.findIndex(x => x.$$uid === $event.$$uid);
    //this.dataManager.rows.splice(rowIndex, 1);
    const rowDel = this.dataManager.rows.find(x => x.$$uid === $event.$$uid);
    if (rowDel)
      this.dataManager.deleteRow(rowDel);

    if (this.service.Rows.indexOf(row + ',') != -1) {
      this.service.Rows = this.service.Rows.replace(row + ',', '').replace('[]', '');
      this.Rows = this.Rows.replace(row + ',', '').replace('[]', '');
    }
    else {
      this.service.Rows = this.service.Rows.replace(row, '').replace('[]', '');
      this.Rows = this.Rows.replace(row, '').replace('[]', '');
    }

    this.multiCritFunc($event.Operator, $event.Value);
    this.currCritListValue = this.currCritListValue.replace(';', '')
    if ($event.Column_Name == 'VQuad Call ID') {
      let callIDArr = this.mainFilter.VQuad_Location.split(';');
      let newVal = "";
      callIDArr.forEach((x, i) => {
        if (x !== this.currCritListValue) {
          if (i > 0)
            newVal += ";";
          newVal += x;
        }
      })

      this.mainFilter.VQuad_Location = newVal;
    }
    else if ($event.Column_Name == 'VQuad DeviceID') {
      let DevIDArr = this.mainFilter.VQuad_PhoneID.split(';');
      let newVal = "";
      DevIDArr.forEach((x, i) => {
        if (x !== this.currCritListValue) {
          if (i > 0)
            newVal += ";";
          newVal += x;
        }
      })

      this.mainFilter.VQuad_PhoneID = newVal;
    }
    else {
      let eventIDArr = this.mainFilter.VQuad_CallID.split(';');
      let newVal = "";
      eventIDArr.forEach((x, i) => {
        if (x !== this.currCritListValue) {
          if (i > 0)
            newVal += ";";
          newVal += x;
        }
      })

      this.mainFilter.VQuad_CallID = newVal;
    }

    this.currCritListValue = ";";//reset

    if (this.Rows == "")
      this.selectedConfig = false;
    else
      this.selectedConfig = true;
  }

  CancelEdit() {
    this.dataManager.selectRow(-1);
    this.onCommonAndResultsBothColsChange('-1');
    this.isTableRowSelected = false;
    this.selRow = "{}";
  }
  onRowDeleted($event) {
    if ($event.Column_Name == 'VQuad Call ID' || $event.Column_Name == 'VQuad DeviceID' || $event.Column_Name == 'VQuad EventID')
      this.onRowCommonDeleted($event);
    else {
      if (!this.replaceAfterDel) {
        let r = confirm("Delete row ?");
        if (r == false)
          return false;
      }

      //this.dataManager.selectRow($event.$$index);
      const rowRsltIdFound = this.results.find(x => x.name === $event.Result_Type);
      if (rowRsltIdFound) {
        const rowRsltId = rowRsltIdFound.id;
        let colIndx = '';
        if (rowRsltId >= 3 && rowRsltId <= 14)
          colIndx = ',"Column_Index":"' + $event.Column_Index + '"';

        let row = '{"Column_OrigName":"' + $event.Column_OrigName + '","NumOrRatingOrStr":"' + $event.NumOrRatingOrStr + '"' + colIndx + ',"Result_Type":"' + $event.Result_Type + '","Column_Name":"' + $event.Column_Name + '","OperatorNum":"' + $event.OperatorNum + '","Operator":"' + $event.Operator + '","Value":"' + $event.Value + '","Value_To":"' + $event.Value_To + '","AndOr":"' + $event.AndOr + '"}';
        ////row = '{"Column_OrigName":"' + colDetails.origName + '","NumOrRatingOrStr":"3"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + colDetails.name + '","OperatorNum":"' + eachOperAndCrit.oper + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + newVal + '","Value_To":"--","AndOr":"' + andOrVal + '"}';
        //const rowIndex = this.dataManager.rows.findIndex(x => x.$$uid === $event.$$uid);
        //this.dataManager.rows.splice(rowIndex, 1);
        const rowDel = this.dataManager.rows.find(x => x.$$uid === $event.$$uid);
        if (rowDel)
          this.dataManager.deleteRow(rowDel);

        if (this.service.Rows.indexOf(row + ',') != -1) {
          this.service.Rows = this.service.Rows.replace(row + ',', '').replace('[]', '');
          this.Rows = this.Rows.replace(row + ',', '').replace('[]', '');
        }
        else if (this.service.Rows.indexOf(',' + row + ']') != -1) {
          this.service.Rows = this.service.Rows.replace(',' + row + ']', ']').replace('[]', '');
          this.Rows = this.Rows.replace(',' + row + ']', ']').replace('[]', '');
        }
        else {
          this.service.Rows = this.service.Rows.replace(row, '').replace('[]', '');
          this.Rows = this.Rows.replace(row, '').replace('[]', '');
        }

        if (rowRsltId == 0) {
          if ($event.Column_OrigName == "PESQ_LQ" && $event.Operator === (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1])
            this.mainFilter.PESQ_LQ_Range = "|";
          else if ($event.Column_OrigName == "Rating") {
            this.mainFilter.PESQ_LQ_Rating = "0|0";
          }
          else {
            //0
            //VQT@|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$Or|VQTData|duration_hangover|LIKE|2|Duration Hangover(s)$ - params after @ and delimited $
            //|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$ - AND/OR  |  Table name   |   Parameter name   |  operator(=/>/</LIKE) | value  |  Alias Param name $
            let currColData = $event.AndOr + "|VQTData|" + $event.Column_OrigName + "|" + $event.OperatorNum + "|" + $event.Value + "|" + $event.Column_Name + "$";
            if ($event.OperatorNum == 6)//In Range
              currColData = $event.AndOr + "|VQTData|" + $event.Column_OrigName + "|" + $event.OperatorNum + "|" + $event.Value + ":" + $event.Value_To + "|" + $event.Column_Name + "$";
            this.mainFilter.CriteriaCondition = this.mainFilter.CriteriaCondition.replace(currColData, '');
            if (this.mainFilter.CriteriaCondition == "VQT@")
              this.mainFilter.CriteriaCondition = "";
          }
        }
        else if (rowRsltId == 1) {
          if ($event.Column_OrigName == "POLQA_Score" && $event.Operator === (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1])
            this.mainFilter.POLQA_Score_Range = "|";
          else if ($event.Column_OrigName == "Pass_Or_Fail") {
            this.mainFilter.POLQA_Score_Rating = "0|0";
          }
          else {
            //1
            //VQTPOLQA@|VQTPOLQA|POLQA_Score|=|8|POLQA_Score$And|VQTPOLQA|EModel_Polqa|<|4|EModel (R-factor)$
            //VQTPOLQA@|VQTPOLQA|ASR_Deg|6|6:7|Active Speech Ratio - Deg (%)$
            //same as above vqt
            let currColData = $event.AndOr + "|VQTPOLQA|" + $event.Column_OrigName + "|" + $event.OperatorNum + "|" + $event.Value + "|" + $event.Column_Name + "$";
            if ($event.OperatorNum == 6)//In Range
              currColData = $event.AndOr + "|VQTPOLQA|" + $event.Column_OrigName + "|" + $event.OperatorNum + "|" + $event.Value + ":" + $event.Value_To + "|" + $event.Column_Name + "$";
            this.mainFilter.POLQACriteriaCondition = this.mainFilter.POLQACriteriaCondition.replace(currColData, '');
            if (this.mainFilter.POLQACriteriaCondition == "VQTPOLQA@")
              this.mainFilter.POLQACriteriaCondition = "";
          }
        }
        else if (rowRsltId == 2) {
          //2 - Audio/Delay
          if ($event.Column_OrigName == "RTD" && $event.Operator === (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1])
            this.mainFilter.RTD_Range = "|";
          else if ($event.Column_OrigName == "OWD" && $event.Operator === (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1])
            this.mainFilter.OWD_Range = "|";
          else if ($event.Column_OrigName == "PDD" && $event.Operator === (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1])
            this.mainFilter.PDD_Range = "|";
          else if ($event.Column_OrigName == "SWR" && $event.Operator === (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1])
            this.mainFilter.SNR_Range = "|";
          else if ($event.Column_OrigName == "RTD_Rating")
            this.mainFilter.RTD_Rating = "0|0";
        }
        else if (rowRsltId >= 3 && rowRsltId <= 11) {
          //3-11
          //;;;;;;;; - nettest
          //AND$1:333@9^OR$9:999@1;AND$2:777@2;AND$3:444@2;;;;;;AND$6:766@2 - delimited by ; for each nettest rslt type

          //AND$1:333@9^OR$9:999@1 - delimited by ^ for each param under curr rslt
          //AND$1:333@9 - AND/OR   $   1(Low) : 333(High)   @   9(param index)
          //; as delimiter between rslt types

          let netTestArr = this.mainFilter.NetTest.split(';');//results
          let newNetTestVal = '';

          netTestArr.forEach((eachNetTest, i) => {
            let limitRslt = ';';
            if (i == 0)
              limitRslt = '';

            if (i == rowRsltId - 3) {//rslt found
              let critParamArr = netTestArr[i].replace(/\^OR/g, '&OR').replace(/\^AND/g, '&AND').split('&');//params of rslt//instead of ^ we are using & for not conflict with doesnot contain oper
              let newCritParamVal = '';
              critParamArr.forEach((eachParamCrit, p) => {
                let limitParam = '&';
                if (p == 0 || newCritParamVal.length == 0)
                  limitParam = '';
                let eachCritAndParamArr = eachParamCrit.split('@');//andor @ paramcrit

                if (eachCritAndParamArr[1] == $event.Column_Index) {//found row's param
                  let multiCritArr = (eachCritAndParamArr[0].split('$'))[1].split('#');

                  let newMultiCrit = '';//empty number range by default
                  if ($event.NumOrRatingOrStr == 3) {//string
                    multiCritArr.forEach(eachCrit => {
                      if (eachCrit !== $event.Value)
                        newMultiCrit += eachCrit + '#';
                    });
                    newMultiCrit = newMultiCrit.substring(0, newMultiCrit.length - 1);
                  }

                  if (newMultiCrit.length > 0)
                    newCritParamVal += limitParam + (eachCritAndParamArr[0].split('$'))[0] + '$' + newMultiCrit + '@' + eachCritAndParamArr[1];
                }
                else
                  newCritParamVal += limitParam + eachParamCrit;
              });

              newNetTestVal += limitRslt + newCritParamVal;
            }
            else
              newNetTestVal += limitRslt + eachNetTest;
          });

          this.mainFilter.NetTest = newNetTestVal;
        }
        else if (rowRsltId >= 12 && rowRsltId <= 14) {
          //12-14
          //;; - mobileinfo
          //AND$1:1000@0;AND$3:3000@0;
          //; as delimiter between rslt types

          let mobileArr = this.mainFilter.Mobile.split(';');//results
          let newMobileVal = '';

          mobileArr.forEach((eachMobile, i) => {
            let limitRslt = ';';
            if (i == 0)
              limitRslt = '';

            if (i == rowRsltId - 12) {//rslt found
              let critParamArr = mobileArr[i].replace(/\^OR/g, '&OR').replace(/\^AND/g, '&AND').split('&');//params of rslt//instead of ^ we are using & for not conflict with doesnot contain oper
              let newCritParamVal = '';
              critParamArr.forEach((eachParamCrit, p) => {
                let limitParam = '&';
                if (p == 0 || newCritParamVal.length == 0)
                  limitParam = '';
                let eachCritAndParamArr = eachParamCrit.split('@');//andor @ paramcrit

                if (eachCritAndParamArr[1] == $event.Column_Index) {//found row's param
                  let multiCritArr = (eachCritAndParamArr[0].split('$'))[1].split('#');

                  let newMultiCrit = '';//empty number range by default
                  if ($event.NumOrRatingOrStr == 3) {//string
                    multiCritArr.forEach(eachCrit => {
                      if (eachCrit !== $event.Value)
                        newMultiCrit += eachCrit + '#';
                    });
                    newMultiCrit = newMultiCrit.substring(0, newMultiCrit.length - 1);
                  }

                  if (newMultiCrit.length > 0)
                    newCritParamVal += limitParam + (eachCritAndParamArr[0].split('$'))[0] + '$' + newMultiCrit + '@' + eachCritAndParamArr[1];
                }
                else
                  newCritParamVal += limitParam + eachParamCrit;
              });

              newMobileVal += limitRslt + newCritParamVal;
            }
            else
              newMobileVal += limitRslt + eachMobile;
          });

          this.mainFilter.Mobile = newMobileVal;
        }
        else if (rowRsltId == 17) {
          //17 - Emodule
          if ($event.Column_OrigName == "MOS_CQ" && $event.Operator === (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1])
            this.mainFilter.MOSCQ_Range = "|";
          else if ($event.Column_OrigName == "VBA_Rating") {
            this.mainFilter.MOSCQ_Rating = "" + '0';
          }
        }
        else if (rowRsltId == 20) {
          //20 - Call events
          if ($event.Column_OrigName == "CC_Condition")
            this.multiCritFunc($event.Operator, $event.Value.replace(';', '~'));
          else
            this.multiCritFunc($event.Operator, $event.Value);
          this.currCritListValue = this.currCritListValue.replace(';', '');
          if ($event.Column_OrigName == 'Call_Control_Event') {
            let ccEventArr = this.mainFilter.Call_Control_Event.split(';');
            let newVal = "";
            ccEventArr.forEach((x, i) => {
              if (x !== this.currCritListValue) {
                if (i > 0)
                  newVal += ";";
                newVal += x;
              }
            })

            this.mainFilter.Call_Control_Event = newVal;
          }
          else if ($event.Column_OrigName == "CC_Condition") {
            let ccCondArr = this.mainFilter.CC_Condition.split(';');
            let newVal = "";
            ccCondArr.forEach((x, i) => {
              if (x !== this.currCritListValue) {
                if (i > 0)
                  newVal += ";";
                newVal += x;
              }
            })

            this.mainFilter.CC_Condition = newVal;
          }
          else if ($event.Column_OrigName == "Called_Number") {
            let callNumArr = this.mainFilter.Called_Number.split(';');
            let newVal = "";
            callNumArr.forEach((x, i) => {
              if (x !== this.currCritListValue) {
                if (i > 0)
                  newVal += ";";
                newVal += x;
              }
            })

            this.mainFilter.Called_Number = newVal;
          }
        }

        let currColItem = this.mainCols.find((x, i) => i === this.selectedMainCols[0]);
        if (currColItem) {
          if (this.Rows.indexOf('{"Column_OrigName":"' + currColItem.origName + '",') == -1) {
            this.selectedAndOrs = [1];
            this.disableAndOr = false;
          }
        }

        this.currCritListValue = ";";//reset

        if (this.Rows == "")
          this.selectedConfig = false;
        else
          this.selectedConfig = true;
      }
    }

    this.selRow = "{}";

    if (!this.replaceAfterDel) {
      this.selParamOperators = this.rangeOperators;
      this.onCommonAndResultsBothColsChange('-1');
    }
    //this.setRsltType(this.Rows);
  }
  //resetDataManagerSelection() {
  //  if (this.dataManager) {
  //    const selection = this.dataManager.selection.getSelection();
  //    if (selection) {
  //      if (selection.length > 0)
  //        this.dataManager.selection.clearSelection();
  //    }
  //  }
  //}


  zIndexCriteriaToggler: number = 2;
  openCritModal() {
    //this.currCritListValue = this.mainValue;
  }
  onCloseCritModal(currCritListValue) {
    this.mainValue = currCritListValue;
  }


  selectedStartDateTime: any;
  selectedEndDateTime: any;
  wrongDateRange: boolean;
  messageSuccess: boolean;
  okOrClear: boolean = true;
  onOKClicked(): void {
    this.wrongDateRange = false;
    if (this.selectedStartDateTime.startDate == null || this.selectedEndDateTime.startDate == null) {
      this.wrongDateRange = true;
      return;
    }
    //let monthsDiff = parseInt(this.selectedTime.endDate.diff(this.selectedTime.startDate, 'months', true));
    let duration = moment.duration(this.selectedEndDateTime.startDate.diff(this.selectedStartDateTime.startDate));
    let monthsDiff = duration.months();
    if (this.selectedTime.startDate.diff(this.selectedTime.endDate) >= 0 || monthsDiff >= 7) {
      this.wrongDateRange = true;
      if (monthsDiff >= 7)
        alert('Dates selection cannot be more than 6 months');
      return;
    }

    this.okOrClear = false;
    this.messageSuccess = true;
    setTimeout(() => {                           //<<<---using ()=> syntax
      this.messageSuccess = false;
    }, 3000);
    //console.log(this.selectedStartEndTime)
  }
  //https://github.com/fetrarij/ngx-daterangepicker-material/blob/master/demo/src/app/simple/simple.component.ts
  onClearClicked(): void {
    this.selectedTime = { startDate: null, endDate: null };
    this.selectedStartDateTime = null;
    this.selectedEndDateTime = null;

    this.wrongDateRange = false;
    this.okOrClear = true;
  }
  onStartDateChanged($event): void {
    if ($event.startDate != null)
      this.selectedTime.startDate = $event.startDate;
  }
  onEndDateChanged($event): void {
    if ($event.startDate != null)
      this.selectedTime.endDate = $event.startDate;
  }
}
